export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CSV: { input: any; output: any; }
  Date: { input: DateString; output: DateString; }
  DateTime: { input: DateTimeString; output: DateTimeString; }
  ImagePath: { input: any; output: any; }
  JISX0402: { input: JISX0402; output: JISX0402; }
  MarkDown: { input: MarkdownString; output: MarkdownString; }
  Time: { input: TimeString; output: TimeString; }
  Uint: { input: number; output: number; }
  Unit: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AddChatMessageTemplateInput = {
  body: Scalars['String']['input'];
  label: Scalars['String']['input'];
  selections: Array<Scalars['String']['input']>;
};

export type AddKartePlannerCommentTemplateInput = {
  body: Scalars['String']['input'];
  label: Scalars['String']['input'];
  selections: Array<Scalars['String']['input']>;
};

export type AddUserVariableDefinitionValueSelectOptionInput = {
  name: Scalars['String']['input'];
  userVariableDefinitionGUID: Scalars['ID']['input'];
};

export type AddUserVariableDefinitionValueSelectOptionPayload = {
  __typename?: 'AddUserVariableDefinitionValueSelectOptionPayload';
  void: Scalars['Void']['output'];
};

export type Address = {
  __typename?: 'Address';
  /** 市区町村 */
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  /** 都道府県 */
  prefecture: Scalars['String']['output'];
  /** 大字・町名 */
  town: Scalars['String']['output'];
};

export type AddressInput = {
  /** 市区町村 */
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  /** 都道府県 */
  prefecture: Scalars['String']['input'];
  /** 大字・町名 */
  town: Scalars['String']['input'];
};

export type AiMatchScore = {
  __typename?: 'AiMatchScore';
  householdImprovementExpectedContractPriceScore: Scalars['Int']['output'];
  householdImprovementMatchingScore: Scalars['Int']['output'];
  jobChangeExpectedContractPriceScore: Scalars['Int']['output'];
  jobChangeMatchingScore: Scalars['Int']['output'];
  lifePlanningExpectedContractPriceScore: Scalars['Int']['output'];
  lifePlanningMatchingScore: Scalars['Int']['output'];
  onetimeSaleExpectedContractPriceScore: Scalars['Int']['output'];
  onetimeSaleMatchingScore: Scalars['Int']['output'];
  realEstateInvestmentExpectedContractPriceScore: Scalars['Int']['output'];
  realEstateInvestmentMatchingScore: Scalars['Int']['output'];
  sellingHomeExpectedContractPriceScore: Scalars['Int']['output'];
  sellingHomeMatchingScore: Scalars['Int']['output'];
};

export type AlreadyExistsConditionalIntroductionMessageError = {
  __typename?: 'AlreadyExistsConditionalIntroductionMessageError';
  message: Scalars['String']['output'];
};

export type AnyAuthzPolicyAction = {
  __typename?: 'AnyAuthzPolicyAction';
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: Maybe<Scalars['Boolean']['output']>;
};

export type AnyAuthzPolicyActionInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnyAuthzPolicyPrincipal = {
  __typename?: 'AnyAuthzPolicyPrincipal';
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: Maybe<Scalars['Boolean']['output']>;
};

export type AnyAuthzPolicyPrincipalInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnyAuthzPolicyResource = {
  __typename?: 'AnyAuthzPolicyResource';
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: Maybe<Scalars['Boolean']['output']>;
};

export type AnyAuthzPolicyResourceInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Area = {
  __typename?: 'Area';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  prefecture?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type AssignStaffToMatchErrorNotAuthorityPayload = {
  __typename?: 'AssignStaffToMatchErrorNotAuthorityPayload';
  message: Scalars['String']['output'];
};

export type AssignStaffToMatchInput = {
  matchID: Scalars['ID']['input'];
  staffGUID: Scalars['ID']['input'];
};

export type AssignStaffToMatchPayload = AssignStaffToMatchErrorNotAuthorityPayload | AssignStaffToMatchSuccessPayload;

export type AssignStaffToMatchSuccessPayload = {
  __typename?: 'AssignStaffToMatchSuccessPayload';
  match: Match;
};

export type AttackListSenderFeature = {
  __typename?: 'AttackListSenderFeature';
  available: Scalars['Boolean']['output'];
  /** 設定できる窓口一覧, available が false のときは空配列 */
  availableCorporationEntrances: Array<Entrance>;
  /** 設定できるプランナー一覧, available が false のときは空配列 */
  availableCorporationPlanners: Array<Planner>;
  /** available が false のときは空配列 */
  settings: Array<AttackListSenderSetting>;
};

export type AttackListSenderSetting = {
  __typename?: 'AttackListSenderSetting';
  body: Scalars['String']['output'];
  entrance: Entrance;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  planner: Planner;
  rule: AttackListSenderSettingRule;
  selections: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AttackListSenderSettingRevision = {
  __typename?: 'AttackListSenderSettingRevision';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
};

/** Range型を取るプロパティに関して、rangeを指定しない場合はNULLでいい */
export type AttackListSenderSettingRule = {
  __typename?: 'AttackListSenderSettingRule';
  age?: Maybe<AttackListSenderSettingRuleRange>;
  ageOfFirstChildRange?: Maybe<AttackListSenderSettingRuleRange>;
  annualIncomeRange?: Maybe<AttackListSenderSettingRuleRange>;
  child: AttackListSenderSettingRuleExistence;
  familyAnnualIncomeRange?: Maybe<AttackListSenderSettingRuleRange>;
  gender: AttackListSenderSettingRuleGender;
  investmentRange?: Maybe<AttackListSenderSettingRuleRange>;
  partner: AttackListSenderSettingRuleExistence;
  savingRange?: Maybe<AttackListSenderSettingRuleRange>;
  shouldSendIfSameCorporationApproached: Scalars['Boolean']['output'];
};

/** パートナー、子どもの存在を表すルールに使う */
export const AttackListSenderSettingRuleExistence = {
  /** 存在する */
  Exist: 'EXIST',
  /** 存在しない */
  NotExist: 'NOT_EXIST',
  /** 指定しない(存在してもしなくてもいい) */
  NotSpecified: 'NOT_SPECIFIED'
} as const;

export type AttackListSenderSettingRuleExistence = typeof AttackListSenderSettingRuleExistence[keyof typeof AttackListSenderSettingRuleExistence];
export const AttackListSenderSettingRuleGender = {
  Female: 'FEMALE',
  Male: 'MALE',
  /** 性別は指定しない */
  NotSpecified: 'NOT_SPECIFIED'
} as const;

export type AttackListSenderSettingRuleGender = typeof AttackListSenderSettingRuleGender[keyof typeof AttackListSenderSettingRuleGender];
export type AttackListSenderSettingRuleInput = {
  age?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  ageOfFirstChildRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  ageOfYoungestChildRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  annualIncomeRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  child: AttackListSenderSettingRuleExistence;
  diagnosisType?: InputMaybe<DiagnosisType>;
  familyAnnualIncomeRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  gender: AttackListSenderSettingRuleGender;
  investmentRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  karteTopicId?: InputMaybe<Scalars['ID']['input']>;
  loanBalanceRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  partner: AttackListSenderSettingRuleExistence;
  savingRange?: InputMaybe<AttackListSenderSettingRuleRangeInput>;
  shouldSendIfSameCorporationApproached: Scalars['Boolean']['input'];
};

/** min, maxどちらか片方を指定したい場合、指定しない方の値はNULLでいい */
export type AttackListSenderSettingRuleRange = {
  __typename?: 'AttackListSenderSettingRuleRange';
  max?: Maybe<Scalars['Uint']['output']>;
  min?: Maybe<Scalars['Uint']['output']>;
};

export type AttackListSenderSettingRuleRangeInput = {
  max?: InputMaybe<Scalars['Uint']['input']>;
  min?: InputMaybe<Scalars['Uint']['input']>;
};

export type AuthzPolicy = {
  __typename?: 'AuthzPolicy';
  action: AuthzPolicyAction;
  effect: AuthzPolicyEffect;
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  principal: AuthzPolicyPrincipal;
  resource: AuthzPolicyResource;
};

export type AuthzPolicyAction = AnyAuthzPolicyAction | ReadRoomAuthzPolicyAction;

export type AuthzPolicyActionInput = {
  /** oneof */
  anyAction?: InputMaybe<AnyAuthzPolicyActionInput>;
  readRoomAction?: InputMaybe<ReadRoomAuthzPolicyActionInput>;
};

export const AuthzPolicyEffect = {
  Forbid: 'FORBID',
  Permit: 'PERMIT'
} as const;

export type AuthzPolicyEffect = typeof AuthzPolicyEffect[keyof typeof AuthzPolicyEffect];
export type AuthzPolicyPrincipal = AnyAuthzPolicyPrincipal | StaffAuthzPolicyPrincipal | TeamAuthzPolicyPrincipal;

export type AuthzPolicyPrincipalInput = {
  /** oneof */
  anyPrincipal?: InputMaybe<AnyAuthzPolicyPrincipalInput>;
  staffPrincipal?: InputMaybe<StaffAuthzPolicyPrincipalInput>;
  teamPrincipal?: InputMaybe<TeamAuthzPolicyPrincipalInput>;
};

export type AuthzPolicyResource = AnyAuthzPolicyResource | RoomAuthzPolicyResource;

export type AuthzPolicyResourceInput = {
  /** oneof */
  anyResource?: InputMaybe<AnyAuthzPolicyResourceInput>;
  roomResource?: InputMaybe<RoomAuthzPolicyResourceInput>;
};

export type AutoChatReplySetting = {
  __typename?: 'AutoChatReplySetting';
  body: Scalars['String']['output'];
  extra: AutoChatReplySettingExtra;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  keyword: Scalars['String']['output'];
};

export type AutoChatReplySettingCopyConflict = {
  __typename?: 'AutoChatReplySettingCopyConflict';
  plannerId: Scalars['ID']['output'];
  setting: AutoChatReplySetting;
};

export const AutoChatReplySettingCopyStrategy = {
  Append: 'APPEND',
  Sync: 'SYNC'
} as const;

export type AutoChatReplySettingCopyStrategy = typeof AutoChatReplySettingCopyStrategy[keyof typeof AutoChatReplySettingCopyStrategy];
export type AutoChatReplySettingDuplicateKeywordError = {
  __typename?: 'AutoChatReplySettingDuplicateKeywordError';
  message: Scalars['String']['output'];
};

export type AutoChatReplySettingExtra = {
  __typename?: 'AutoChatReplySettingExtra';
  bookingRequest?: Maybe<AutoChatReplySettingExtraBookingRequest>;
  /** 次のプロパティは extraType に対応した値が Non-null になっている */
  question?: Maybe<AutoChatReplySettingExtraQuestion>;
  type: AutoChatReplySettingExtraType;
};

export type AutoChatReplySettingExtraBookingRequest = {
  __typename?: 'AutoChatReplySettingExtraBookingRequest';
  assignedCalendarGuid?: Maybe<Scalars['ID']['output']>;
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
  fallbackUrl?: Maybe<Scalars['String']['output']>;
};

export type AutoChatReplySettingExtraQuestion = {
  __typename?: 'AutoChatReplySettingExtraQuestion';
  selections: Array<AutoChatReplySettingExtraQuestionSelectionItem>;
};

export type AutoChatReplySettingExtraQuestionSelectionItem = {
  __typename?: 'AutoChatReplySettingExtraQuestionSelectionItem';
  link?: Maybe<AutoChatReplySetting>;
  text: Scalars['String']['output'];
};

export const AutoChatReplySettingExtraType = {
  BookingRequest: 'BOOKING_REQUEST',
  None: 'NONE',
  Question: 'QUESTION'
} as const;

export type AutoChatReplySettingExtraType = typeof AutoChatReplySettingExtraType[keyof typeof AutoChatReplySettingExtraType];
export type AutoChatReplySettingInputExtra = {
  bookingRequest?: InputMaybe<AutoChatReplySettingInputExtraBookingRequest>;
  /** 次のプロパティは extraType に対応した値が Non-null になっている */
  question?: InputMaybe<AutoChatReplySettingInputExtraQuestion>;
  type: AutoChatReplySettingExtraType;
};

export type AutoChatReplySettingInputExtraBookingRequest = {
  assignedCalendarGuid?: InputMaybe<Scalars['ID']['input']>;
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
  fallbackUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AutoChatReplySettingInputExtraQuestion = {
  selections: Array<Scalars['String']['input']>;
};

export type AutoPostKartePlannerCommentFeature = {
  __typename?: 'AutoPostKartePlannerCommentFeature';
  available: Scalars['Boolean']['output'];
  /** available が false の場合は null */
  setting?: Maybe<AutoPostKartePlannerCommentSetting>;
};

export type AutoPostKartePlannerCommentSetting = {
  __typename?: 'AutoPostKartePlannerCommentSetting';
  comment: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  selections: Array<Scalars['String']['output']>;
};

export type AutoPostKartePlannerCommentSettingInput = {
  comment: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  selections: Array<Scalars['String']['input']>;
};

/**
 * リフレッシュトークンが期限切れになっている場合など、カレンダーとの連携が無効になっている場合に返るエラー
 * 無効になった認証情報は削除されている
 */
export type AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection = {
  __typename?: 'AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection';
  message: Scalars['String']['output'];
};

export type AvailableBookingRequestTimeSlotsErrorNoCalendarConnected = {
  __typename?: 'AvailableBookingRequestTimeSlotsErrorNoCalendarConnected';
  message: Scalars['String']['output'];
};

export type AvailableBookingRequestTimeSlotsPayload = AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection | AvailableBookingRequestTimeSlotsErrorNoCalendarConnected | AvailableBookingRequestTimeSlotsSuccess;

export type AvailableBookingRequestTimeSlotsSuccess = {
  __typename?: 'AvailableBookingRequestTimeSlotsSuccess';
  timeSlots: Array<BookingRequestTimeSlot>;
};

export type BaseError = {
  message: Scalars['String']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  assignedStaff: Staff;
  cancelReason?: Maybe<BookingCancelReason>;
  description?: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['Time']['output'];
  guid: Scalars['ID']['output'];
  meetingURL?: Maybe<Scalars['String']['output']>;
  okanekoUser?: Maybe<User>;
  questionAnswers: Array<QuestionAnswer>;
  startsAt: Scalars['Time']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  userGUID: Scalars['ID']['output'];
};

export const BookingCancelReason = {
  EntranceCancelled: 'ENTRANCE_CANCELLED',
  UserCancelled: 'USER_CANCELLED'
} as const;

export type BookingCancelReason = typeof BookingCancelReason[keyof typeof BookingCancelReason];
export type BookingConnection = {
  __typename?: 'BookingConnection';
  edges: Array<BookingEdge>;
  pageInfo: BookingPageInfo;
};

export type BookingEdge = {
  __typename?: 'BookingEdge';
  cursor: Scalars['String']['output'];
  node: Booking;
};

export type BookingPageInfo = {
  __typename?: 'BookingPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type BookingRequestTimeSlot = {
  __typename?: 'BookingRequestTimeSlot';
  endsAt: Scalars['Time']['output'];
  startsAt: Scalars['Time']['output'];
};

export type Branch = {
  __typename?: 'Branch';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Calendar = {
  __typename?: 'Calendar';
  assignedStaffs: Array<CalendarAssignedStaff>;
  bookings: BookingConnection;
  createdAt: Scalars['Time']['output'];
  dailyAvailabilities: Array<CalendarDailyAvailability>;
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['ID']['output'];
  privateTitle?: Maybe<Scalars['String']['output']>;
  publicTitle: Scalars['String']['output'];
  questions: Array<CalendarQuestion>;
  slotDurationMinutes: Scalars['Uint']['output'];
  slotGenerationDelayHours: Scalars['Uint']['output'];
  slotGenerationPeriodDays: Scalars['Uint']['output'];
  slotOffsetMinutes: Scalars['Uint']['output'];
  staffSelectionStrategy: CalendarStaffSelectionStrategy;
  status: CalendarStatus;
};


export type CalendarBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Uint']['input'];
};

export type CalendarAssignedStaff = {
  __typename?: 'CalendarAssignedStaff';
  displayName: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  priority?: Maybe<Scalars['Uint']['output']>;
};

export type CalendarAssignedStaffInput = {
  guid: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Uint']['input']>;
};

export type CalendarDailyAvailability = {
  __typename?: 'CalendarDailyAvailability';
  dayOfWeek: DayOfWeek;
  from: CalendarTimeOfDay;
  until: CalendarTimeOfDay;
};

export type CalendarDailyAvailabilityInput = {
  dayOfWeek: DayOfWeek;
  from: CalendarTimeOfDayInput;
  until: CalendarTimeOfDayInput;
};

export type CalendarInUseByScheduleAdjustmentError = {
  __typename?: 'CalendarInUseByScheduleAdjustmentError';
  message: Scalars['String']['output'];
};

export type CalendarQuestion = {
  order: Scalars['Uint']['output'];
  questionText: Scalars['String']['output'];
  status: CalendarQuestionStatus;
  type: CalendarQuestionType;
};

export type CalendarQuestionInput = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order: Scalars['Uint']['input'];
  questionText: Scalars['String']['input'];
  status: CalendarQuestionStatus;
  type: CalendarQuestionType;
};

export type CalendarQuestionSelectBox = CalendarQuestion & {
  __typename?: 'CalendarQuestionSelectBox';
  options: Array<Scalars['String']['output']>;
  order: Scalars['Uint']['output'];
  questionText: Scalars['String']['output'];
  status: CalendarQuestionStatus;
  type: CalendarQuestionType;
};

export const CalendarQuestionStatus = {
  Optional: 'OPTIONAL',
  Required: 'REQUIRED'
} as const;

export type CalendarQuestionStatus = typeof CalendarQuestionStatus[keyof typeof CalendarQuestionStatus];
export type CalendarQuestionText = CalendarQuestion & {
  __typename?: 'CalendarQuestionText';
  order: Scalars['Uint']['output'];
  questionText: Scalars['String']['output'];
  status: CalendarQuestionStatus;
  type: CalendarQuestionType;
};

export const CalendarQuestionType = {
  SelectBox: 'SELECT_BOX',
  Text: 'TEXT'
} as const;

export type CalendarQuestionType = typeof CalendarQuestionType[keyof typeof CalendarQuestionType];
export type CalendarSettingInput = {
  assignedStaffs: Array<CalendarAssignedStaffInput>;
  dailyAvailabilities: Array<CalendarDailyAvailabilityInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  privateTitle?: InputMaybe<Scalars['String']['input']>;
  publicTitle: Scalars['String']['input'];
  questions: Array<CalendarQuestionInput>;
  slotDurationMinutes: Scalars['Uint']['input'];
  slotGenerationDelayHours: Scalars['Uint']['input'];
  slotGenerationPeriodDays: Scalars['Uint']['input'];
  slotOffsetMinutes: Scalars['Uint']['input'];
  staffSelectionStrategy: CalendarStaffSelectionStrategy;
  status: CalendarStatus;
};

export const CalendarStaffSelectionStrategy = {
  Priority: 'PRIORITY',
  Random: 'RANDOM'
} as const;

export type CalendarStaffSelectionStrategy = typeof CalendarStaffSelectionStrategy[keyof typeof CalendarStaffSelectionStrategy];
export const CalendarStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type CalendarStatus = typeof CalendarStatus[keyof typeof CalendarStatus];
export type CalendarSummary = {
  __typename?: 'CalendarSummary';
  assignedStaffs: Array<CalendarAssignedStaff>;
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['ID']['output'];
  privateTitle?: Maybe<Scalars['String']['output']>;
  publicTitle: Scalars['String']['output'];
  status: CalendarStatus;
};

export type CalendarTimeOfDay = {
  __typename?: 'CalendarTimeOfDay';
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
};

export type CalendarTimeOfDayInput = {
  hours: Scalars['Int']['input'];
  minutes: Scalars['Int']['input'];
};

export type CancelBookingPayload = {
  __typename?: 'CancelBookingPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type CancelKollegeUserCourse = {
  userCourseID: Scalars['ID']['input'];
};

export type CardMetric = {
  __typename?: 'CardMetric';
  averageValue: Scalars['Uint']['output'];
  message: Scalars['String']['output'];
  myValue: Scalars['Uint']['output'];
  name: Scalars['String']['output'];
  rank?: Maybe<RankInCluster>;
  showBarGraph: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type Cards = {
  __typename?: 'Cards';
  annualIncome: CardMetric;
  investment: CardMetric;
  monthlyInsurance: CardMetric;
  monthlyRentCost: CardMetric;
  savingAnnual: CardMetric;
};

export type ChangePasswordWithLoggedInPayload = {
  __typename?: 'ChangePasswordWithLoggedInPayload';
  success: Scalars['Boolean']['output'];
};

export type ChangePasswordWithoutLoggedInPayload = {
  __typename?: 'ChangePasswordWithoutLoggedInPayload';
  success: Scalars['Boolean']['output'];
};

export const Channel = {
  /** 中国銀行 */
  ChugokuGinko: 'CHUGOKU_GINKO',
  /** ファミペイ */
  Famipay: 'FAMIPAY',
  /** 400F */
  FourHundredF: 'FOUR_HUNDRED_F',
  /** 400F 保険比較 */
  FourHundredFInsuranceComparison: 'FOUR_HUNDRED_F_INSURANCE_COMPARISON',
  /** はなさく生命 */
  Hanasaku: 'HANASAKU',
  /** ほけんの窓口 */
  HokenNoMadoguchi: 'HOKEN_NO_MADOGUCHI',
  /** ゆうちょ銀行 */
  JpBank: 'JP_BANK',
  /** きらぼし銀行 */
  Kiraboshi: 'KIRABOSHI',
  /** ライフプラザパートナーズ */
  LifePlaza: 'LIFE_PLAZA',
  /** メットライフ生命 */
  MetLife: 'MET_LIFE',
  /** みんかぶ */
  Minkabu: 'MINKABU',
  /** マネーフォワード */
  MoneyForward: 'MONEY_FORWARD',
  /** ninpath */
  Ninpath: 'NINPATH',
  /** オカネコ */
  Okaneko: 'OKANEKO',
  /** オカネコ転職 */
  OkanekoTenshoku: 'OKANEKO_TENSHOKU',
  /** OKB */
  Okb: 'OKB',
  /** オリックス銀行 */
  OrixBank: 'ORIX_BANK',
  /** Ponta */
  Ponta: 'PONTA',
  /** 楽天証券 */
  Rakuten: 'RAKUTEN',
  /** 楽天証券インハウスアドバイザー */
  RakutenInHouseAdvisor: 'RAKUTEN_IN_HOUSE_ADVISOR',
  /** 楽天証券の運用相談 */
  RakutenUnyouSoudan: 'RAKUTEN_UNYOU_SOUDAN',
  /** SBI証券 */
  Sbi: 'SBI',
  /** SBIマネープラザ */
  SbiMoneyPlaza: 'SBI_MONEY_PLAZA',
  /** SBI証券の運用相談 */
  SbiUnyouSoudan: 'SBI_UNYOU_SOUDAN',
  /** 三井住友カード */
  Smcc: 'SMCC',
  /** トヨタカローラ */
  ToyotaCorolla: 'TOYOTA_COROLLA',
  /** Vitalityスマート */
  VitalitySmart: 'VITALITY_SMART',
  /** Yahoo! JAPAN */
  Yahoo: 'YAHOO',
  /** 財形住宅金融 */
  ZaikeiJutakuKinyu: 'ZAIKEI_JUTAKU_KINYU'
} as const;

export type Channel = typeof Channel[keyof typeof Channel];
export type ChannelItem = {
  __typename?: 'ChannelItem';
  id: Channel;
  name: Scalars['String']['output'];
};

export const ChatMessageAttachmentType = {
  /** 日程調整 */
  BookingRequest: 'BOOKING_REQUEST'
} as const;

export type ChatMessageAttachmentType = typeof ChatMessageAttachmentType[keyof typeof ChatMessageAttachmentType];
export type ChatMessageSendingJob = {
  __typename?: 'ChatMessageSendingJob';
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  guid: Scalars['ID']['output'];
  messages: Array<ChatMessageSendingJobMessage>;
  scheduledAt?: Maybe<Scalars['Time']['output']>;
  sentAt?: Maybe<Scalars['Time']['output']>;
  statistics?: Maybe<ChatMessageSendingJobStatistics>;
  status: ChatMessageSendingJobStatus;
  target: Scalars['String']['output'];
};

export type ChatMessageSendingJobConnection = {
  __typename?: 'ChatMessageSendingJobConnection';
  edges: Array<ChatMessageSendingJobEdge>;
  pageInfo: PageInfo;
};

export type ChatMessageSendingJobEdge = {
  __typename?: 'ChatMessageSendingJobEdge';
  cursor: Scalars['String']['output'];
  node: ChatMessageSendingJob;
};

export type ChatMessageSendingJobMessage = ChatMessageSendingJobMessageImage | ChatMessageSendingJobMessageQuestion | ChatMessageSendingJobMessageText;

export type ChatMessageSendingJobMessageImage = {
  __typename?: 'ChatMessageSendingJobMessageImage';
  altText: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  imageUri: Scalars['String']['output'];
  linkUri: Scalars['String']['output'];
};

export type ChatMessageSendingJobMessageQuestion = {
  __typename?: 'ChatMessageSendingJobMessageQuestion';
  body: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  selections: Array<Scalars['String']['output']>;
};

export type ChatMessageSendingJobMessageText = {
  __typename?: 'ChatMessageSendingJobMessageText';
  guid: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ChatMessageSendingJobStatistics = {
  __typename?: 'ChatMessageSendingJobStatistics';
  click: Array<ChatMessageSendingJobStatisticsClick>;
  message: Array<ChatMessageSendingJobStatisticsMessage>;
  overview: ChatMessageSendingJobStatisticsOverview;
};

export type ChatMessageSendingJobStatisticsClick = {
  __typename?: 'ChatMessageSendingJobStatisticsClick';
  click?: Maybe<Scalars['Int']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  uniqueClick?: Maybe<Scalars['Int']['output']>;
  uniqueClickOfRequest?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageSendingJobStatisticsMessage = {
  __typename?: 'ChatMessageSendingJobStatisticsMessage';
  impression?: Maybe<Scalars['Int']['output']>;
  mediaPlayed?: Maybe<Scalars['Int']['output']>;
  mediaPlayed25Percent?: Maybe<Scalars['Int']['output']>;
  mediaPlayed50Percent?: Maybe<Scalars['Int']['output']>;
  mediaPlayed75Percent?: Maybe<Scalars['Int']['output']>;
  mediaPlayed100Percent?: Maybe<Scalars['Int']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  uniqueImpression?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed25Percent?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed50Percent?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed75Percent?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed100Percent?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessageSendingJobStatisticsOverview = {
  __typename?: 'ChatMessageSendingJobStatisticsOverview';
  uniqueClick?: Maybe<Scalars['Int']['output']>;
  uniqueImpression?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed?: Maybe<Scalars['Int']['output']>;
  uniqueMediaPlayed100Percent?: Maybe<Scalars['Int']['output']>;
};

export const ChatMessageSendingJobStatus = {
  ChatMessageSendingJobStatusCompleted: 'ChatMessageSendingJobStatusCompleted',
  ChatMessageSendingJobStatusFailed: 'ChatMessageSendingJobStatusFailed',
  ChatMessageSendingJobStatusPending: 'ChatMessageSendingJobStatusPending',
  ChatMessageSendingJobStatusRunning: 'ChatMessageSendingJobStatusRunning'
} as const;

export type ChatMessageSendingJobStatus = typeof ChatMessageSendingJobStatus[keyof typeof ChatMessageSendingJobStatus];
/** チャット状況 */
export const ChatMessageStatus = {
  /** 返信済み */
  Replied: 'Replied',
  /** 未読 */
  Unread: 'Unread',
  /** 未返信 */
  Unreplied: 'Unreplied'
} as const;

export type ChatMessageStatus = typeof ChatMessageStatus[keyof typeof ChatMessageStatus];
export type ChatMessageTemplate = {
  __typename?: 'ChatMessageTemplate';
  body: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  selections: Array<Scalars['String']['output']>;
};

export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  id: Scalars['ID']['output'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  /** アップロードされた日時の降順に並ぶ */
  filesFor400FOa: Array<ChatRoomFile>;
  /** 自分以外のChatRoomではfalseになる */
  hasUnreadMessage: Scalars['Boolean']['output'];
  /** 自分以外のChatRoomではfalseになる */
  hasUnrepliedMessage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** derekDBのmatchesのレコードは物理削除されているが、roomのレコードは存在しているものがある */
  match: Match;
  /** 自身のメモのみ返す。Memberのメモは返さない */
  memos: Array<ChatRoomMemo>;
  planner: Planner;
  status: ChatRoomStatus;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  /** user が既読しているうち最新のメッセージのguid */
  userLatestReadMessageGUID?: Maybe<Scalars['ID']['output']>;
  userUploadPageUrl?: Maybe<Scalars['String']['output']>;
};

export type ChatRoomConnection = {
  __typename?: 'ChatRoomConnection';
  edges?: Maybe<Array<Maybe<ChatRoomEdge>>>;
  pageInfo: ChatRoomPageInfo;
};

export type ChatRoomEdge = {
  __typename?: 'ChatRoomEdge';
  cursor: Scalars['String']['output'];
  node: ChatRoom;
};

export type ChatRoomFile = {
  __typename?: 'ChatRoomFile';
  canManuallySendDownloadURL: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['Time']['output'];
};

export type ChatRoomFilterInput = {
  chatMessageStatuses?: InputMaybe<Array<ChatMessageStatus>>;
  lastMessageSentAt?: InputMaybe<ChatRoomFilterLastMessageSendAtInput>;
  memoStatuses?: InputMaybe<Array<ChatRoomMemoStatus>>;
  statuses?: InputMaybe<Array<ChatRoomStatus>>;
};

export type ChatRoomFilterLastMessageSendAtInput = {
  /** endedAtがnullの場合はstartedAt移行のもの全てを返す */
  endedAt?: InputMaybe<Scalars['Time']['input']>;
  startedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ChatRoomInputFile = {
  contentType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type ChatRoomMemo = {
  __typename?: 'ChatRoomMemo';
  /** メモの内容 */
  content: Scalars['String']['output'];
  /** メモの作成日時 */
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
};

export const ChatRoomMemoStatus = {
  HasMemo: 'HAS_MEMO',
  NoMemo: 'NO_MEMO'
} as const;

export type ChatRoomMemoStatus = typeof ChatRoomMemoStatus[keyof typeof ChatRoomMemoStatus];
export type ChatRoomPageInfo = {
  __typename?: 'ChatRoomPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export const ChatRoomStatus = {
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  ActionRequired: 'ActionRequired',
  /** 面談済み・対応中 */
  Appointed: 'Appointed',
  /** 対応不要 */
  Archived: 'Archived',
  /** 契約済み */
  ContractConcluded: 'ContractConcluded',
  /** 保険契約済み */
  ContractConcludedInsurance: 'ContractConcludedInsurance',
  /** 証券契約済み */
  ContractConcludedSecurities: 'ContractConcludedSecurities',
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  GotComplaints: 'GotComplaints',
  /** 後追い対応 */
  Keeping: 'Keeping',
  /** 失注 */
  LostOrder: 'LostOrder',
  /** チャット対応中 */
  Messaging: 'Messaging',
  /** 未設定 */
  NotDefined: 'NotDefined',
  /** 面談設定中 */
  Offering: 'Offering',
  /** 初回面談実施待ち */
  WaitingForFirstAppointment: 'WaitingForFirstAppointment'
} as const;

export type ChatRoomStatus = typeof ChatRoomStatus[keyof typeof ChatRoomStatus];
export type Child = {
  __typename?: 'Child';
  birthday: Scalars['Date']['output'];
  gender: Gender;
};

export type ChildInput = {
  birthday: Scalars['Date']['input'];
  gender: Gender;
};

export type ChildrenState = {
  __typename?: 'ChildrenState';
  answer: ChildrenStateAnswer;
  children: Array<Child>;
};

export const ChildrenStateAnswer = {
  /** 子どもがいる */
  HasChildren: 'HAS_CHILDREN',
  /** 子どもがいない */
  HasNoChildren: 'HAS_NO_CHILDREN',
  /** 回答しない */
  NoAnswer: 'NO_ANSWER',
  /** 未回答 */
  Unanswered: 'UNANSWERED'
} as const;

export type ChildrenStateAnswer = typeof ChildrenStateAnswer[keyof typeof ChildrenStateAnswer];
export type ChildrenStateInput = {
  answer: ChildrenStateAnswer;
  children: Array<ChildInput>;
};

export type City = {
  __typename?: 'City';
  jisx0402: Scalars['JISX0402']['output'];
  name: Scalars['String']['output'];
};

export type CompleteUploadKollegeReceiptInput = {
  paymentId: Scalars['ID']['input'];
};

export type CompleteUploadKollegeReceiptResponse = {
  __typename?: 'CompleteUploadKollegeReceiptResponse';
  success: Scalars['Boolean']['output'];
};

export type Condition = SegmentConditionClickUrlCondition | SegmentConditionEnqueteAnswered | SegmentConditionInflowSource | SegmentConditionLoginLink | SegmentConditionRoomStatus;

export type ConditionInput = {
  clickURLCondition?: InputMaybe<SegmentConditionClickUrlConditionInput>;
  enqueteAnsweredCondition?: InputMaybe<SegmentConditionEnqueteAnsweredInput>;
  inflowSourceCondition?: InputMaybe<SegmentConditionInflowSourceInput>;
  loginLinkCondition?: InputMaybe<SegmentConditionLoginLinkInput>;
  roomStatusCondition?: InputMaybe<SegmentConditionRoomStatusInput>;
  userVariableDefinitionCondition?: InputMaybe<SegmentConditionUserVariableDefinitionInput>;
};

export type ConditionalIntroductionMessage = {
  __typename?: 'ConditionalIntroductionMessage';
  condition: IntroductionMessageCondition;
  content: IntroductionMessageContent;
  guid: Scalars['ID']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  contractType: ContractType;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceCustomerName: Scalars['String']['output'];
  isCreditCardAvailable: Scalars['Boolean']['output'];
  isEditablePeriod: Scalars['Boolean']['output'];
  paymentMethod: PaymentMethod;
};

export const ContractType = {
  Corporate: 'CORPORATE',
  Individual: 'INDIVIDUAL',
  Unknown: 'UNKNOWN'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];
export type Corporation = {
  __typename?: 'Corporation';
  branches: Array<Branch>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CreateAttackListSenderSettingInput = {
  body: Scalars['String']['input'];
  entranceGuid?: InputMaybe<Scalars['ID']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  plannerId?: InputMaybe<Scalars['ID']['input']>;
  rule: AttackListSenderSettingRuleInput;
  selections: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAttackListSenderSettingsInput = {
  settings: Array<CreateAttackListSenderSettingsInputSetting>;
};

export type CreateAttackListSenderSettingsInputSetting = {
  body: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  plannerEmail: Scalars['String']['input'];
  rule: AttackListSenderSettingRuleInput;
  selections: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAttackListSenderSettingsPayload = {
  __typename?: 'CreateAttackListSenderSettingsPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type CreateAuthzPolicyInput = {
  action: AuthzPolicyActionInput;
  effect: AuthzPolicyEffect;
  name: Scalars['String']['input'];
  principal: AuthzPolicyPrincipalInput;
  resource: AuthzPolicyResourceInput;
};

export type CreateAuthzPolicyPayload = CreateAuthzPolicySuccessPayload;

export type CreateAuthzPolicySuccessPayload = {
  __typename?: 'CreateAuthzPolicySuccessPayload';
  authzPolicy: AuthzPolicy;
};

export type CreateAutoChatReplySettingInput = {
  body: Scalars['String']['input'];
  extra: AutoChatReplySettingInputExtra;
  isEnabled: Scalars['Boolean']['input'];
  keyword: Scalars['String']['input'];
};

export type CreateAutoChatReplySettingPayload = AutoChatReplySettingDuplicateKeywordError | SaveAutoChatReplySettingSuccess;

export type CreateCalendarInput = {
  setting: CalendarSettingInput;
};

export type CreateCalendarPayload = {
  __typename?: 'CreateCalendarPayload';
  guid: Scalars['ID']['output'];
};

export type CreateConditionalIntroductionMessageInput = {
  condition: IntroductionMessageConditionInput;
  content: IntroductionMessageContentInput;
};

export type CreateConditionalIntroductionMessagePayload = AlreadyExistsConditionalIntroductionMessageError | SaveIntroductionMessageSuccess;

export type CreateEnqueteInput = {
  enquete: EnqueteInput;
};

export type CreateEnquetePayload = {
  __typename?: 'CreateEnquetePayload';
  guid: Scalars['ID']['output'];
};

export type CreateKollegeExpenseRecordDailyLessonInput = {
  startsAt: Scalars['Time']['input'];
  userCourseGUID: Scalars['ID']['input'];
};

export type CreateLineRichMenuInput = {
  lineRichMenu: LineRichMenuInput;
};

export type CreateLineRichMenuPayload = CreateLineRichMenuSuccessPayload | LineRichMenuErrorPayload;

export type CreateLineRichMenuSuccessPayload = {
  __typename?: 'CreateLineRichMenuSuccessPayload';
  lineRichMenu: LineRichMenu;
};

export type CreateScenarioChatInput = {
  messages: Array<ScenarioChatMessageInput>;
  title: Scalars['String']['input'];
};

export type CreateScenarioChatPayload = {
  __typename?: 'CreateScenarioChatPayload';
  guid: Scalars['ID']['output'];
};

export type CreateStaffErrorAlreadyExistsPayload = {
  __typename?: 'CreateStaffErrorAlreadyExistsPayload';
  message: Scalars['String']['output'];
};

export type CreateStaffInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<StaffRole>;
};

export type CreateStaffPayload = CreateStaffErrorAlreadyExistsPayload | CreateStaffSuccessPayload;

export type CreateStaffSuccessPayload = {
  __typename?: 'CreateStaffSuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateStepDeliveryInput = {
  IsDisabled: Scalars['Boolean']['input'];
  addFriendDate?: InputMaybe<Scalars['Date']['input']>;
  cond: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
  steps: Array<StepDeliveryStepInput>;
};

export type CreateStepDeliveryPayload = {
  __typename?: 'CreateStepDeliveryPayload';
  StepDelivery: StepDelivery;
};

export type CreateTeamInput = {
  name: Scalars['String']['input'];
  staffGUIDs: Array<Scalars['ID']['input']>;
};

export type CreateTeamPayload = CreateTeamSuccessPayload;

export type CreateTeamSuccessPayload = {
  __typename?: 'CreateTeamSuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateUserRegistrationInflowSourceDefinitionInput = {
  inflowSourceName: Scalars['String']['input'];
  matchAssignedStaffGUIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  useShortenedURL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserRegistrationInflowSourceDefinitionPayload = {
  __typename?: 'CreateUserRegistrationInflowSourceDefinitionPayload';
  guid: Scalars['ID']['output'];
};

export type CreateUserVariableDefinitionInput = {
  dataType: UserVariableDefinitionDataType;
  name: Scalars['String']['input'];
  selectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateUserVariableDefinitionPayload = {
  __typename?: 'CreateUserVariableDefinitionPayload';
  guid: Scalars['ID']['output'];
};

export const DayOfWeek = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];
export type DefaultIntroductionMessage = {
  __typename?: 'DefaultIntroductionMessage';
  content: IntroductionMessageContent;
  guid: Scalars['ID']['output'];
};

export type DeleteAllCorporationSettingsPayload = {
  __typename?: 'DeleteAllCorporationSettingsPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type DeleteAttackListSenderSettingsPayload = {
  __typename?: 'DeleteAttackListSenderSettingsPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type DeleteAuthzPolicyInput = {
  guid: Scalars['ID']['input'];
};

export type DeleteAuthzPolicyPayload = DeleteAuthzPolicySuccessPayload;

export type DeleteAuthzPolicySuccessPayload = {
  __typename?: 'DeleteAuthzPolicySuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteAutoChatReplySettingsPayload = {
  __typename?: 'DeleteAutoChatReplySettingsPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type DeleteCalendarInput = {
  guid: Scalars['ID']['input'];
};

export type DeleteCalendarPayload = CalendarInUseByScheduleAdjustmentError | DeleteCalendarSuccess;

export type DeleteCalendarSuccess = {
  __typename?: 'DeleteCalendarSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteChatMessageSendingJobErrorPayload = {
  __typename?: 'DeleteChatMessageSendingJobErrorPayload';
  reason: Scalars['String']['output'];
};

export type DeleteChatMessageSendingJobInput = {
  guid: Scalars['ID']['input'];
};

export type DeleteChatMessageSendingJobPayload = DeleteChatMessageSendingJobErrorPayload | DeleteChatMessageSendingJobSuccessPayload;

export type DeleteChatMessageSendingJobSuccessPayload = {
  __typename?: 'DeleteChatMessageSendingJobSuccessPayload';
  jobGuid?: Maybe<Scalars['ID']['output']>;
};

export type DeleteLineRichMenuPayload = {
  __typename?: 'DeleteLineRichMenuPayload';
  void: Scalars['Void']['output'];
};

export type DeleteNormalMessageChatReplyPlannerSettingPayload = {
  __typename?: 'DeleteNormalMessageChatReplyPlannerSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteScenarioChatErrorAssociatedWithIntroductionMessage = {
  __typename?: 'DeleteScenarioChatErrorAssociatedWithIntroductionMessage';
  message: Scalars['String']['output'];
};

export type DeleteScenarioChatSuccess = {
  __typename?: 'DeleteScenarioChatSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteScenarioChatV2Payload = DeleteScenarioChatErrorAssociatedWithIntroductionMessage | DeleteScenarioChatSuccess;

export type DeleteStaffInput = {
  guid: Scalars['ID']['input'];
};

export type DeleteStaffPayload = DeleteStaffSuccessPayload;

export type DeleteStaffSuccessPayload = {
  __typename?: 'DeleteStaffSuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteStepDeliveryPayload = {
  __typename?: 'DeleteStepDeliveryPayload';
  void: Scalars['Void']['output'];
};

export type DeleteTeamInput = {
  guid: Scalars['ID']['input'];
};

export type DeleteTeamPayload = DeleteTeamSuccessPayload;

export type DeleteTeamSuccessPayload = {
  __typename?: 'DeleteTeamSuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  aiMatchScore?: Maybe<AiMatchScore>;
  annualIncome: Scalars['Uint']['output'];
  birthYear: Scalars['Uint']['output'];
  children: Array<DiagnosisChild>;
  diagnosisSummary?: Maybe<DiagnosisSummary>;
  followsTheLatestTrends: Scalars['Boolean']['output'];
  gender: Gender;
  hasGoalInFuture: Scalars['Boolean']['output'];
  hasOldAgeFund?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  investment: Scalars['Uint']['output'];
  isInterestedInNisaOrIdeco: Scalars['Boolean']['output'];
  isPlanningLifeEvent?: Maybe<Scalars['Boolean']['output']>;
  isSavingMonthly?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Job>;
  knowsLoanInterestRate?: Maybe<Scalars['Boolean']['output']>;
  livingPrefecture: Prefecture;
  loanBalance?: Maybe<Scalars['Uint']['output']>;
  monthlyInsurance: Scalars['Uint']['output'];
  monthlyRentCost: Scalars['Uint']['output'];
  partner?: Maybe<DiagnosisPartner>;
  postalCode?: Maybe<Scalars['String']['output']>;
  saving: Scalars['Uint']['output'];
  savingMonth: Scalars['Uint']['output'];
  shareUuid: Scalars['String']['output'];
  signsUpForInsurance?: Maybe<Scalars['Boolean']['output']>;
  takesThreeOrMoreLessons: Scalars['Boolean']['output'];
  thinksCareerForIncome?: Maybe<Scalars['Boolean']['output']>;
  thinksToughTimesBringOpportunity: Scalars['Boolean']['output'];
  thinksWhatDoneIsDone: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
  worriesEducationFund?: Maybe<Scalars['Boolean']['output']>;
  worriesHousingLoan?: Maybe<Scalars['Boolean']['output']>;
};

export type DiagnosisByKarte = {
  __typename?: 'DiagnosisByKarte';
  cards: Cards;
  diagnosisResult: Diagnosis;
  personality: Personality;
  user: DiagnosisUser;
};

export type DiagnosisByUser = {
  __typename?: 'DiagnosisByUser';
  cards: Cards;
  diagnosisResult: Diagnosis;
  personality: Personality;
};

export type DiagnosisChild = {
  __typename?: 'DiagnosisChild';
  age: Scalars['Int']['output'];
  gender: Gender;
};

export type DiagnosisCluster = {
  __typename?: 'DiagnosisCluster';
  householdStructure: HouseholdStructureType;
  residentialArea: Area;
  statistics: DiagnosisClusterStatistics;
};

export type DiagnosisClusterStatistics = {
  __typename?: 'DiagnosisClusterStatistics';
  investmentRatio: Scalars['Float']['output'];
  meanAge: Scalars['Float']['output'];
  meanAssets: Scalars['Float']['output'];
  meanHouseholdAnnualIncome: Scalars['Float']['output'];
  meanMonthlySaving: Scalars['Float']['output'];
  meanNumberOfChildren: Scalars['Float']['output'];
  numberOfSamples: Scalars['Uint']['output'];
};

export type DiagnosisKarte = {
  __typename?: 'DiagnosisKarte';
  channel: Channel;
  id: Scalars['ID']['output'];
  modifiedAt: Scalars['Time']['output'];
  plannerCommentCount: Scalars['Uint']['output'];
  sameBranchPlannerCommented: Scalars['Boolean']['output'];
};

export type DiagnosisKarteTopic = {
  __typename?: 'DiagnosisKarteTopic';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DiagnosisPartner = {
  __typename?: 'DiagnosisPartner';
  annualIncome: Scalars['Uint']['output'];
  birthYear: Scalars['Uint']['output'];
};

export type DiagnosisResult = {
  __typename?: 'DiagnosisResult';
  personality: Personality;
};

export type DiagnosisSummary = {
  __typename?: 'DiagnosisSummary';
  assetsRank: RankInCluster;
  cluster: DiagnosisCluster;
  householdAnnualIncomeRank: RankInCluster;
  monthlySavingRank: RankInCluster;
  simpleLifePlanning: SimpleLifePlanning;
  type: DiagnosisType;
};

export const DiagnosisType = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H'
} as const;

export type DiagnosisType = typeof DiagnosisType[keyof typeof DiagnosisType];
export type DiagnosisUser = {
  __typename?: 'DiagnosisUser';
  annualIncome: Scalars['Uint']['output'];
  children: Array<Child>;
  gender: Gender;
  hasChild: Scalars['Boolean']['output'];
  hasPartner: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  investment: Scalars['Uint']['output'];
  karte: DiagnosisKarte;
  livingPrefecture: Scalars['String']['output'];
  monthlyInsurance: Scalars['Uint']['output'];
  nickname: Scalars['String']['output'];
  partnerAnnualIncome?: Maybe<Scalars['Uint']['output']>;
  personality: Personality;
  saving: Scalars['Uint']['output'];
  yearOfBirth: Scalars['Uint']['output'];
};

export type DiagnosisUserKarteComment = {
  __typename?: 'DiagnosisUserKarteComment';
  noIdea: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type DiagnosisUserKarteTopics = {
  __typename?: 'DiagnosisUserKarteTopics';
  noIdea: Scalars['Boolean']['output'];
  values: Array<DiagnosisKarteTopic>;
};

export type DisableNormalMessageChatReplyMatchSettingInput = {
  roomID: Scalars['ID']['input'];
};

export type DisableNormalMessageChatReplyMatchSettingPayload = {
  __typename?: 'DisableNormalMessageChatReplyMatchSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type EducationEvent = {
  __typename?: 'EducationEvent';
  childLabel: Scalars['String']['output'];
  type: EducationEventType;
};

export const EducationEventType = {
  EsAdmission: 'ES_ADMISSION',
  HsAdmission: 'HS_ADMISSION',
  JhsAdmission: 'JHS_ADMISSION',
  UnivAdmission: 'UNIV_ADMISSION',
  UnivGraduation: 'UNIV_GRADUATION'
} as const;

export type EducationEventType = typeof EducationEventType[keyof typeof EducationEventType];
export type EnableNormalMessageChatReplyMatchSettingInput = {
  roomID: Scalars['ID']['input'];
};

export type EnableNormalMessageChatReplyMatchSettingPayload = {
  __typename?: 'EnableNormalMessageChatReplyMatchSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type Enquete = {
  __typename?: 'Enquete';
  answerCount: Scalars['Uint']['output'];
  answerEnqueteLiffAppPageUrl?: Maybe<Scalars['String']['output']>;
  answeredChatMessage?: Maybe<EnqueteAnsweredChatMessage>;
  guid: Scalars['ID']['output'];
  questions: Array<EnqueteQuestion>;
  title: Scalars['String']['output'];
};

export type EnqueteAnsweredChatMessage = {
  __typename?: 'EnqueteAnsweredChatMessage';
  body: Scalars['String']['output'];
  selections?: Maybe<Array<Scalars['String']['output']>>;
};

export type EnqueteAnsweredChatMessageInput = {
  body: Scalars['String']['input'];
  selections?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EnqueteInput = {
  answeredChatMessage?: InputMaybe<EnqueteAnsweredChatMessageInput>;
  questions: Array<EnqueteQuestionInput>;
  title: Scalars['String']['input'];
};

export type EnquetePayload = {
  __typename?: 'EnquetePayload';
  enquete: Enquete;
};

export type EnqueteQuestion = {
  __typename?: 'EnqueteQuestion';
  guid: Scalars['ID']['output'];
  isAnswerRequired: Scalars['Boolean']['output'];
  questionText: Scalars['String']['output'];
  userVariableDefinition: UserVariableDefinition;
};

export type EnqueteQuestionInput = {
  /** 新規で作成された EnqueteQuestionInput は null である */
  guid?: InputMaybe<Scalars['ID']['input']>;
  isAnswerRequired: Scalars['Boolean']['input'];
  questionText: Scalars['String']['input'];
  userVariableDefinitionGUID: Scalars['ID']['input'];
};

export type EnquetesInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type EnquetesPayload = {
  __typename?: 'EnquetesPayload';
  enquetes: Array<Enquete>;
  paginationInfo: OffsetBasedPageInfo;
};

export type Entrance = {
  __typename?: 'Entrance';
  allBookings: BookingConnection;
  calendarSummaries: Array<CalendarSummary>;
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type EntranceAllBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Uint']['input'];
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export const ExtraBookingRequestAvailableTimeSlotRange = {
  Anytime: 'ANYTIME',
  WeekdayAnytime: 'WEEKDAY_ANYTIME',
  WeekdayDaytime: 'WEEKDAY_DAYTIME',
  WeekdayNight: 'WEEKDAY_NIGHT',
  WeekendAnytime: 'WEEKEND_ANYTIME',
  WeekendDaytime: 'WEEKEND_DAYTIME',
  WeekendNight: 'WEEKEND_NIGHT'
} as const;

export type ExtraBookingRequestAvailableTimeSlotRange = typeof ExtraBookingRequestAvailableTimeSlotRange[keyof typeof ExtraBookingRequestAvailableTimeSlotRange];
export type For400FoaIssueSignedUploadUrlPayload = {
  __typename?: 'For400FOAIssueSignedUploadURLPayload';
  items: Array<For400FoaIssueSignedUploadUrlPayloadItem>;
};

export type For400FoaIssueSignedUploadUrlPayloadItem = {
  __typename?: 'For400FOAIssueSignedUploadURLPayloadItem';
  signedUploadURL: Scalars['String']['output'];
  uploadRequestId: Scalars['ID']['output'];
};

export type For400FoaSendFileDownloadUrlPayload = {
  __typename?: 'For400FOASendFileDownloadURLPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export const Gender = {
  Female: 'FEMALE',
  Male: 'MALE',
  NoAnswer: 'NO_ANSWER',
  Other: 'OTHER'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];
export const HouseholdStructureType = {
  /** 子なし夫婦世帯 */
  CoupleWithoutChildren: 'COUPLE_WITHOUT_CHILDREN',
  /** 子あり夫婦世帯 */
  CoupleWithChildren: 'COUPLE_WITH_CHILDREN',
  /** 単身世帯 */
  OnePerson: 'ONE_PERSON',
  /** 定年後世帯 */
  Retired: 'RETIRED',
  /** ひとり親世帯 */
  SingleWithChildren: 'SINGLE_WITH_CHILDREN',
  Unspecified: 'UNSPECIFIED'
} as const;

export type HouseholdStructureType = typeof HouseholdStructureType[keyof typeof HouseholdStructureType];
export type IntroductionMessageCondition = {
  __typename?: 'IntroductionMessageCondition';
  userRegistrationInflowSourceDefinition: UserRegistrationInflowSourceDefinition;
};

export type IntroductionMessageConditionInput = {
  userRegistrationInflowSourceDefinitionGUID: Scalars['ID']['input'];
};

export type IntroductionMessageContent = PlainIntroductionMessageContent | ScenarioChatIntroductionMessageContent;

export type IntroductionMessageContentInput = {
  /** oneof */
  plainIntroductionMessage?: InputMaybe<PlainIntroductionMessageInput>;
  scenarioChatIntroductionMessage?: InputMaybe<ScenarioChatIntroductionMessageInput>;
};

export type IntroductionMessageSetting = {
  __typename?: 'IntroductionMessageSetting';
  conditional: Array<ConditionalIntroductionMessage>;
  default?: Maybe<DefaultIntroductionMessage>;
};

export type IssueChatMessageImageUploadUrlInput = {
  fileExtension: Scalars['String']['input'];
};

export type IssueChatMessageImageUploadUrlPayload = {
  __typename?: 'IssueChatMessageImageUploadUrlPayload';
  fileName: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type IssueDownloadKollegeReceiptUrlInput = {
  paymentId: Scalars['ID']['input'];
};

export type IssueDownloadKollegeReceiptUrlResponse = {
  __typename?: 'IssueDownloadKollegeReceiptUrlResponse';
  presignedUrl: Scalars['String']['output'];
};

export type IssueEnqueteAnswersCsvFileDownloadUrlInput = {
  enqueteGUID: Scalars['ID']['input'];
};

export type IssueEnqueteAnswersCsvFileDownloadUrlPayload = {
  __typename?: 'IssueEnqueteAnswersCsvFileDownloadURLPayload';
  downloadURL: Scalars['String']['output'];
};

export type IssueLineRichMenuBackgroundImageUploadUrlInput = {
  fileExtension: Scalars['String']['input'];
};

export type IssueLineRichMenuBackgroundImageUploadUrlPayload = {
  __typename?: 'IssueLineRichMenuBackgroundImageUploadUrlPayload';
  fileName: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type IssueLoginLinkUrlFromCsvErrorProviderNotFoundPayload = {
  __typename?: 'IssueLoginLinkURLFromCSVErrorProviderNotFoundPayload';
  message: Scalars['String']['output'];
};

export type IssueLoginLinkUrlFromCsvInput = {
  csv: Scalars['CSV']['input'];
};

export type IssueLoginLinkUrlFromCsvPayload = IssueLoginLinkUrlFromCsvErrorProviderNotFoundPayload | IssueLoginLinkUrlFromCsvSuccessPayload;

export type IssueLoginLinkUrlFromCsvSuccessPayload = {
  __typename?: 'IssueLoginLinkURLFromCSVSuccessPayload';
  csv: Scalars['CSV']['output'];
};

export type IssueLoginLinkUrlWithIdGenerationErrorProviderNotFoundPayload = {
  __typename?: 'IssueLoginLinkURLWithIDGenerationErrorProviderNotFoundPayload';
  message: Scalars['String']['output'];
};

export type IssueLoginLinkUrlWithIdGenerationInput = {
  size: Scalars['Uint']['input'];
};

export type IssueLoginLinkUrlWithIdGenerationPayload = IssueLoginLinkUrlWithIdGenerationErrorProviderNotFoundPayload | IssueLoginLinkUrlWithIdGenerationSuccessPayload;

export type IssueLoginLinkUrlWithIdGenerationSuccessPayload = {
  __typename?: 'IssueLoginLinkURLWithIDGenerationSuccessPayload';
  csv: Scalars['CSV']['output'];
};

export type IssueMicrosoftOAuthUrlPayload = {
  __typename?: 'IssueMicrosoftOAuthURLPayload';
  url: Scalars['String']['output'];
};

export type IssuePlannerAvatarImageUploadUrlPayload = {
  __typename?: 'IssuePlannerAvatarImageUploadUrlPayload';
  path: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
};

export type IssuePlannerCoverImageUploadUrlPayload = {
  __typename?: 'IssuePlannerCoverImageUploadUrlPayload';
  path: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
};

export type IssueStaffAvatarImageUploadUrlPayload = {
  __typename?: 'IssueStaffAvatarImageUploadUrlPayload';
  uploadURL: Scalars['String']['output'];
};

export type IssueUploadKollegeReceiptUrlInput = {
  paymentId: Scalars['ID']['input'];
};

export type IssueUploadKollegeReceiptUrlResponse = {
  __typename?: 'IssueUploadKollegeReceiptUrlResponse';
  presignedUrl: Scalars['String']['output'];
};

export type JpyRange = {
  max?: InputMaybe<Scalars['Uint']['input']>;
  min?: InputMaybe<Scalars['Uint']['input']>;
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Karte = {
  __typename?: 'Karte';
  channel: Channel;
  channelItem: ChannelItem;
  diagnosis: Diagnosis;
  hasCommentsFromPlannersBelongingToSameBranch: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isLikelyToMatch: Scalars['Boolean']['output'];
  kartePlannerCommentAvailability: KartePlannerCommentAvailability;
  modifiedAt: Scalars['Time']['output'];
  numberOfPlannerComments: Scalars['Uint']['output'];
  ownKartePlannerComment?: Maybe<KartePlannerComment>;
  topics: Array<KarteTopic>;
  user: User;
  userComment: Scalars['String']['output'];
};

export type KarteConnection = {
  __typename?: 'KarteConnection';
  edges: Array<KarteEdge>;
  pageInfo: KartePageInfo;
};

export type KarteEdge = {
  __typename?: 'KarteEdge';
  cursor: Scalars['String']['output'];
  node: Karte;
};

export type KartePageInfo = {
  __typename?: 'KartePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type KartePlannerComment = {
  __typename?: 'KartePlannerComment';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  selections?: Maybe<Array<Scalars['String']['output']>>;
};

export type KartePlannerCommentAvailability = {
  __typename?: 'KartePlannerCommentAvailability';
  availability: Scalars['Boolean']['output'];
  unavailableReason?: Maybe<KartePlannerCommentUnavailableReason>;
};

/** 料金プランのバージョンごとに集計の仕方が変わるのでどの集計結果か見て使い分けるべし */
export type KartePlannerCommentMonthlyAmount = ManageOnlyFreePlanKartePlannerCommentMonthlyAmount | V2021_1KartePlannerCommentMonthlyAmount | V2022_1KartePlannerCommentMonthlyAmount | V2023_1KartePlannerCommentMonthlyAmount;

export type KartePlannerCommentPreview = {
  __typename?: 'KartePlannerCommentPreview';
  comment: Scalars['String']['output'];
  selections: Array<Scalars['String']['output']>;
};

export type KartePlannerCommentTemplate = {
  __typename?: 'KartePlannerCommentTemplate';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  selections: Array<Scalars['String']['output']>;
};

export const KartePlannerCommentUnavailableReason = {
  /** 同カルテにカルテコメントを送信済みのためアプローチできない */
  AlreadyCommented: 'ALREADY_COMMENTED',
  /** すでにマッチしているユーザーのためアプローチできない */
  AlreadyMatched: 'ALREADY_MATCHED',
  /** プラン開始前(契約期間前)のためアプローチできない */
  BeforeContractPeriod: 'BEFORE_CONTRACT_PERIOD',
  /** プランナーがカルテに対応するチャネルを持っていないためアプローチできない */
  ChannelDoesNotMatch: 'CHANNEL_DOES_NOT_MATCH',
  /** 管理者専用無料プランのためコメントできない */
  HasManageOnlyFreePlan: 'HAS_MANAGE_ONLY_FREE_PLAN',
  /** PRプランのため、アプローチできない */
  HasPrPlan: 'HAS_PR_PLAN',
  /** プランナーの月ごとの送信数上限に達したためアプローチできない */
  ReachedToMonthlyLimit: 'REACHED_TO_MONTHLY_LIMIT',
  /** 上記の理由以外においてエラー */
  Unknown: 'UNKNOWN'
} as const;

export type KartePlannerCommentUnavailableReason = typeof KartePlannerCommentUnavailableReason[keyof typeof KartePlannerCommentUnavailableReason];
export type KarteTopic = {
  __typename?: 'KarteTopic';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type KartenFilter = {
  addresses?: InputMaybe<Array<Scalars['JISX0402']['input']>>;
  annualIncomeRange?: InputMaybe<JpyRange>;
  channels?: InputMaybe<Array<Channel>>;
  gender?: InputMaybe<Gender>;
  generation?: InputMaybe<Array<KartenFilterUserGeneration>>;
  hasAlreadyBeenCommentedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  hasChild?: InputMaybe<Scalars['Boolean']['input']>;
  hasPartner?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserComment?: InputMaybe<Scalars['Boolean']['input']>;
  investmentRange?: InputMaybe<JpyRange>;
  jobIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  loanBalanceRange?: InputMaybe<JpyRange>;
  monthlyInsuranceRange?: InputMaybe<JpyRange>;
  partnerAnnualIncomeRange?: InputMaybe<JpyRange>;
  savingRange?: InputMaybe<JpyRange>;
  totalAssetsRange?: InputMaybe<JpyRange>;
};

export const KartenFilterUserGeneration = {
  /**
   * シンボルの先頭に数字を使うことができないので冗長だけどプレフィックス
   * https://spec.graphql.org/June2018/#sec-Names
   */
  Gen_20SOrLower: 'GEN_20S_OR_LOWER',
  Gen_30S: 'GEN_30S',
  Gen_40S: 'GEN_40S',
  Gen_50S: 'GEN_50S',
  Gen_60SOrUpper: 'GEN_60S_OR_UPPER'
} as const;

export type KartenFilterUserGeneration = typeof KartenFilterUserGeneration[keyof typeof KartenFilterUserGeneration];
export const KollegeCourse = {
  Standardv20250418: 'Standardv20250418'
} as const;

export type KollegeCourse = typeof KollegeCourse[keyof typeof KollegeCourse];
export type KollegeCoursePersonalLesson = {
  __typename?: 'KollegeCoursePersonalLesson';
  description: Scalars['String']['output'];
  goal: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lessonOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** 支出項目 */
export type KollegeExpenseItem = {
  __typename?: 'KollegeExpenseItem';
  amount?: Maybe<Scalars['Int']['output']>;
  sakugenkahi?: Maybe<KollegeSakugenkahi>;
};

/** 支出記録デイリーレッスン */
export type KollegeExpenseRecordDailyLesson = {
  __typename?: 'KollegeExpenseRecordDailyLesson';
  guid: Scalars['ID']['output'];
  input: Array<KollegeExpenseRecordDailyLessonInput>;
  period?: Maybe<KollegeExpenseRecordDailyLessonPeriod>;
  /** @deprecated Use `period` instead. */
  startedAt?: Maybe<Scalars['Time']['output']>;
};


/** 支出記録デイリーレッスン */
export type KollegeExpenseRecordDailyLessonInputArgs = {
  nth_day?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** 支出記録デイリーレッスンの入力データ */
export type KollegeExpenseRecordDailyLessonInput = {
  __typename?: 'KollegeExpenseRecordDailyLessonInput';
  expenseBiyouhi: KollegeExpenseItem;
  expenseGasolinedai: KollegeExpenseItem;
  expenseGorakuhi: KollegeExpenseItem;
  expenseHifukuhi: KollegeExpenseItem;
  expenseIryohi: KollegeExpenseItem;
  expenseKodomohi: KollegeExpenseItem;
  expenseKousaihi: KollegeExpenseItem;
  expenseKoutsuhi: KollegeExpenseItem;
  expenseNichiyouhin: KollegeExpenseItem;
  expenseShokuhi: KollegeExpenseItem;
  expenseTokubetsuhi: KollegeExpenseItem;
  expenseZappi: KollegeExpenseItem;
  guid: Scalars['ID']['output'];
  instructorComment?: Maybe<Scalars['String']['output']>;
  nth_day: Scalars['Int']['output'];
  state: KollegeExpenseRecordDailyLessonInputState;
  title: Scalars['String']['output'];
};

/** 支出記録デイリーレッスンの入力ステータス */
export const KollegeExpenseRecordDailyLessonInputState = {
  Draft: 'DRAFT',
  Filled: 'FILLED',
  NotInput: 'NOT_INPUT'
} as const;

export type KollegeExpenseRecordDailyLessonInputState = typeof KollegeExpenseRecordDailyLessonInputState[keyof typeof KollegeExpenseRecordDailyLessonInputState];
/** 支出記録デイリーレッスンの開始日/終了日 */
export type KollegeExpenseRecordDailyLessonPeriod = {
  __typename?: 'KollegeExpenseRecordDailyLessonPeriod';
  endsAt: Scalars['Time']['output'];
  startsAt: Scalars['Time']['output'];
};

export const KollegeGender = {
  Female: 'Female',
  Male: 'Male'
} as const;

export type KollegeGender = typeof KollegeGender[keyof typeof KollegeGender];
export type KollegeInstructor = {
  __typename?: 'KollegeInstructor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type KollegePayment = KollegePayment_Fincode;

export type KollegePayment_Fincode = {
  __typename?: 'KollegePayment_Fincode';
  fincodeOrderURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUploadedReceipt: Scalars['Boolean']['output'];
};

/** 削減可否 */
export const KollegeSakugenkahi = {
  /** 一部削減可 */
  IchibuSakugenka: 'ICHIBU_SAKUGENKA',
  /** 削減可 */
  Sakugenka: 'SAKUGENKA',
  /** 削減不可 */
  SakugenFuka: 'SAKUGEN_FUKA'
} as const;

export type KollegeSakugenkahi = typeof KollegeSakugenkahi[keyof typeof KollegeSakugenkahi];
export type KollegeSchedule = {
  __typename?: 'KollegeSchedule';
  endsAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  startsAt: Scalars['Time']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type KollegeUser = {
  __typename?: 'KollegeUser';
  address?: Maybe<KollegeUserAddress>;
  email?: Maybe<KollegeUserEmail>;
  id: Scalars['ID']['output'];
  /** 入力がないときは空文字 */
  instructorMemo: Scalars['String']['output'];
  isAntiSocial?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<KollegeUserProfile>;
  standardCourse?: Maybe<KollegeUserCourse_StandardV20250418>;
  trial?: Maybe<KollegeUserTrial>;
  trials: Array<KollegeUserTrial>;
};


export type KollegeUserTrialArgs = {
  id: Scalars['ID']['input'];
};

export type KollegeUserAddress = {
  __typename?: 'KollegeUserAddress';
  building: Scalars['String']['output'];
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  town: Scalars['String']['output'];
};

export type KollegeUserConnection = {
  __typename?: 'KollegeUserConnection';
  edges: Array<KollegeUserEdge>;
  pageInfo: PageInfo;
};

export type KollegeUserCourse = KollegeUserCourse_StandardV20250418;

export type KollegeUserCourseLesson = {
  __typename?: 'KollegeUserCourseLesson';
  courseLesson: KollegeCoursePersonalLesson;
  id: Scalars['ID']['output'];
  instructor: KollegeInstructor;
  schedule?: Maybe<KollegeSchedule>;
  status: KollegeUserCourseLessonStatus;
};

export const KollegeUserCourseLessonStatus = {
  Absented: 'Absented',
  Booked: 'Booked',
  Completed: 'Completed',
  Unbooked: 'Unbooked'
} as const;

export type KollegeUserCourseLessonStatus = typeof KollegeUserCourseLessonStatus[keyof typeof KollegeUserCourseLessonStatus];
export const KollegeUserCourseStatus = {
  Applied: 'APPLIED',
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  InProgress: 'IN_PROGRESS',
  NotApplied: 'NOT_APPLIED'
} as const;

export type KollegeUserCourseStatus = typeof KollegeUserCourseStatus[keyof typeof KollegeUserCourseStatus];
export type KollegeUserCourse_StandardV20250418 = {
  __typename?: 'KollegeUserCourse_StandardV20250418';
  allLessons: Array<KollegeUserCourseLesson>;
  expenseRecordDailyLesson?: Maybe<KollegeExpenseRecordDailyLesson>;
  id: Scalars['ID']['output'];
  instructor?: Maybe<KollegeInstructor>;
  lastCompletedLesson?: Maybe<KollegeUserCourseLesson>;
  payment?: Maybe<KollegePayment>;
  period?: Maybe<UserCoursePeriod>;
  status: KollegeUserCourseStatus;
};

export type KollegeUserEdge = {
  __typename?: 'KollegeUserEdge';
  cursor: Scalars['String']['output'];
  node: KollegeUser;
};

export type KollegeUserEmail = {
  __typename?: 'KollegeUserEmail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActivated: Scalars['Boolean']['output'];
};

export type KollegeUserProfile = {
  __typename?: 'KollegeUserProfile';
  birthDate: Scalars['Time']['output'];
  familyName: Scalars['String']['output'];
  familyNameKana: Scalars['String']['output'];
  gender: KollegeGender;
  givenName: Scalars['String']['output'];
  givenNameKana: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type KollegeUserTrial = {
  __typename?: 'KollegeUserTrial';
  course: KollegeCourse;
  id: Scalars['ID']['output'];
  schedule?: Maybe<KollegeSchedule>;
  status: KollegeUserTrialStatus;
};

export const KollegeUserTrialStatus = {
  Booked: 'Booked',
  Completed: 'Completed',
  UnBooked: 'UnBooked'
} as const;

export type KollegeUserTrialStatus = typeof KollegeUserTrialStatus[keyof typeof KollegeUserTrialStatus];
export const KollegeUsersFilterAntiSocialStatus = {
  /** 反社チェックNG */
  IsAntiSocial: 'IsAntiSocial',
  /** 反社チェックOK */
  NotAntiSocial: 'NotAntiSocial',
  /** まだ反社チェックしてない */
  Unknown: 'Unknown'
} as const;

export type KollegeUsersFilterAntiSocialStatus = typeof KollegeUsersFilterAntiSocialStatus[keyof typeof KollegeUsersFilterAntiSocialStatus];
export type KollegeUsersFilterConditions = {
  antiSocialStatus?: InputMaybe<KollegeUsersFilterAntiSocialStatus>;
  instructor?: InputMaybe<Array<Scalars['ID']['input']>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userStatus?: InputMaybe<Array<KollegeUsersFilterUserStatus>>;
};

export const KollegeUsersFilterUserStatus = {
  /** コースに申し込んで講師アサイン待ち */
  CourseApplied: 'CourseApplied',
  /** コース解約済 */
  CourseCancelled: 'CourseCancelled',
  /** コース修了 */
  CourseCompleted: 'CourseCompleted',
  /** コース受講中 */
  CourseInProgress: 'CourseInProgress',
  /** 無料体験会に申し込んだ */
  TrialBooked: 'TrialBooked',
  /** 無料体験会が完了し、コース未申込 */
  TrialCompletedAndCourseNotApplied: 'TrialCompletedAndCourseNotApplied',
  /** 無料体験会に申し込んでない */
  TrialNotBooked: 'TrialNotBooked'
} as const;

export type KollegeUsersFilterUserStatus = typeof KollegeUsersFilterUserStatus[keyof typeof KollegeUsersFilterUserStatus];
export type LineActivationProviderLiffAppConfig = {
  __typename?: 'LINEActivationProviderLiffAppConfig';
  canEditRedirectURI: Scalars['Boolean']['output'];
  clientId: Scalars['String']['output'];
  liffId: Scalars['String']['output'];
  loginRedirectUri: Scalars['String']['output'];
};

export type LineActivationProviderSetting = {
  __typename?: 'LineActivationProviderSetting';
  liffId?: Maybe<Scalars['String']['output']>;
  lineChannelId?: Maybe<Scalars['String']['output']>;
  lineFollowUrl?: Maybe<Scalars['String']['output']>;
  messageApiAccessToken: Scalars['String']['output'];
  messageApiChannelSecret: Scalars['String']['output'];
};

export type LineActivationUser = {
  __typename?: 'LineActivationUser';
  isBlocked: Scalars['Boolean']['output'];
};

export type LineMessagingCurrentMonthQuota = LineMessagingCurrentMonthQuota_Limited | LineMessagingCurrentMonthQuota_None;

export type LineMessagingCurrentMonthQuotaPayload = {
  __typename?: 'LineMessagingCurrentMonthQuotaPayload';
  quota: LineMessagingCurrentMonthQuota;
  totalUsage: Scalars['Int']['output'];
};

export type LineMessagingCurrentMonthQuota_Limited = {
  __typename?: 'LineMessagingCurrentMonthQuota_Limited';
  limit: Scalars['Int']['output'];
};

export type LineMessagingCurrentMonthQuota_None = {
  __typename?: 'LineMessagingCurrentMonthQuota_None';
  void: Scalars['Void']['output'];
};

export type LineRichMenu = {
  __typename?: 'LineRichMenu';
  backgroundImageFileName: Scalars['String']['output'];
  chatBarText: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  isDisplayDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  segment?: Maybe<Segment>;
  status: LineRichMenuStatus;
  targetType: TargetType;
  templateActions: Array<LineRichMenuTemplateAction>;
  templateName: Scalars['String']['output'];
};

export const LineRichMenuActionType = {
  Link: 'LINK',
  Text: 'TEXT'
} as const;

export type LineRichMenuActionType = typeof LineRichMenuActionType[keyof typeof LineRichMenuActionType];
export type LineRichMenuErrorPayload = {
  __typename?: 'LineRichMenuErrorPayload';
  reason: LineRichMenuErrorReason;
};

export const LineRichMenuErrorReason = {
  /** 同一セグメントの公開リッチメニューがすでに存在する */
  DuplicateSegmentPublished: 'DUPLICATE_SEGMENT_PUBLISHED',
  /** 上記の理由以外においてエラー */
  Unknown: 'UNKNOWN'
} as const;

export type LineRichMenuErrorReason = typeof LineRichMenuErrorReason[keyof typeof LineRichMenuErrorReason];
export type LineRichMenuInput = {
  backgroundImageFileName: Scalars['String']['input'];
  chatBarText: Scalars['String']['input'];
  isDisplayDefault: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  segment?: InputMaybe<SegmentInput>;
  status: LineRichMenuStatus;
  targetType: TargetType;
  template: Scalars['String']['input'];
  templateActions: Array<InputMaybe<LineRichMenuTemplateActionInput>>;
};

export type LineRichMenuPayload = {
  __typename?: 'LineRichMenuPayload';
  lineRichMenu: LineRichMenu;
};

export const LineRichMenuStatus = {
  Published: 'PUBLISHED',
  Unpublished: 'UNPUBLISHED'
} as const;

export type LineRichMenuStatus = typeof LineRichMenuStatus[keyof typeof LineRichMenuStatus];
export type LineRichMenuTemplateAction = {
  __typename?: 'LineRichMenuTemplateAction';
  actionType: LineRichMenuActionType;
  label?: Maybe<Scalars['String']['output']>;
  panelName: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LineRichMenuTemplateActionInput = {
  actionType: LineRichMenuActionType;
  label?: InputMaybe<Scalars['String']['input']>;
  panelName: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ListLineRichMenu = {
  __typename?: 'ListLineRichMenu';
  guid: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  status: LineRichMenuStatus;
};

export type ListLineRichMenuPayload = {
  __typename?: 'ListLineRichMenuPayload';
  lineRichMenus: Array<ListLineRichMenu>;
};

/** 管理専用無料プランのため、コメント送信数などを持たない */
export type ManageOnlyFreePlanKartePlannerCommentMonthlyAmount = {
  __typename?: 'ManageOnlyFreePlanKartePlannerCommentMonthlyAmount';
  /** empty な type にしないために用意しているフィールド。アプリケーションからは使わない */
  _dummyField?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkAsAbsentedKollegeUserCourseLessonInput = {
  userCourseLessonID: Scalars['ID']['input'];
};

export type MarkAsCompletedKollegeUserCourseLessonInput = {
  userCourseLessonID: Scalars['ID']['input'];
};

export type Match = {
  __typename?: 'Match';
  assignedStaffs: Array<Staff>;
  id: Scalars['ID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  matchedAt: Scalars['Time']['output'];
  normalMessageChatReplyMatchSetting: NormalMessageChatReplyMatchSetting;
};

export type MatchAssigned = {
  __typename?: 'MatchAssigned';
  staffs: Array<Staff>;
};

export type MatchStatus = {
  __typename?: 'MatchStatus';
  createdAt: Scalars['Time']['output'];
  hasTalked: Scalars['Boolean']['output'];
  inflowSource: Scalars['String']['output'];
  numberOfMessages: Scalars['Int']['output'];
  plannerId: Scalars['ID']['output'];
};

export type MatchStatusesInSameBranchErrorNotAuthorityPayload = {
  __typename?: 'MatchStatusesInSameBranchErrorNotAuthorityPayload';
  message: Scalars['String']['output'];
};

export type MatchStatusesInSameBranchPayload = MatchStatusesInSameBranchErrorNotAuthorityPayload | MatchStatusesInSameBranchSuccessPayload;

export type MatchStatusesInSameBranchSuccessPayload = {
  __typename?: 'MatchStatusesInSameBranchSuccessPayload';
  matchStatuses: Array<MatchStatus>;
};

export type MatchStatusesInSameCorporationErrorNotAuthorityPayload = {
  __typename?: 'MatchStatusesInSameCorporationErrorNotAuthorityPayload';
  message: Scalars['String']['output'];
};

export type MatchStatusesInSameCorporationPayload = MatchStatusesInSameCorporationErrorNotAuthorityPayload | MatchStatusesInSameCorporationSuccessPayload;

export type MatchStatusesInSameCorporationSuccessPayload = {
  __typename?: 'MatchStatusesInSameCorporationSuccessPayload';
  matchStatuses: Array<MatchStatus>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** 追加後にプランナーが持つすべてのChatMessageTemplate を返す */
  addChatMessageTemplate: Array<ChatMessageTemplate>;
  addChatRoomMemo: ChatRoom;
  /** 追加後にプランナーが持つすべての KartePlannerCommentTemplate を返す */
  addKartePlannerCommentTemplate: Array<KartePlannerCommentTemplate>;
  addUserVariableDefinitionValueSelectOption: AddUserVariableDefinitionValueSelectOptionPayload;
  agreeTerms: Viewer;
  assignStaffToMatch: AssignStaffToMatchPayload;
  cancelBooking?: Maybe<CancelBookingPayload>;
  cancelKollegeUserCourse?: Maybe<KollegeUserCourse>;
  changePasswordWithLoggedIn: ChangePasswordWithLoggedInPayload;
  changePasswordWithoutLoggedIn: ChangePasswordWithoutLoggedInPayload;
  completeKollegeUserTrial: KollegeUserTrial;
  completeUploadKollegeReceipt: CompleteUploadKollegeReceiptResponse;
  copyAutoChatReplySettings: Scalars['Unit']['output'];
  createAttackListSenderSetting: AttackListSenderSetting;
  createAuthzPolicy: CreateAuthzPolicyPayload;
  createAutoChatReplySetting: CreateAutoChatReplySettingPayload;
  createCalendar: CreateCalendarPayload;
  createConditionalIntroductionMessage: CreateConditionalIntroductionMessagePayload;
  createCorporationAttackListSenderSettings: CreateAttackListSenderSettingsPayload;
  createEnquete: CreateEnquetePayload;
  createKollegeExpenseRecordDailyLesson: KollegeExpenseRecordDailyLesson;
  createLineRichMenu: CreateLineRichMenuPayload;
  createScenarioChat: CreateScenarioChatPayload;
  createSeminarSchedules: Seminar;
  createStaff: CreateStaffPayload;
  createStepDelivery: CreateStepDeliveryPayload;
  createTeam: CreateTeamPayload;
  createUserRegistrationInflowSourceDefinition: CreateUserRegistrationInflowSourceDefinitionPayload;
  createUserVariableDefinition: CreateUserVariableDefinitionPayload;
  deleteAllCorporationAttackListSenderSettings: DeleteAllCorporationSettingsPayload;
  deleteAttackListSenderSettings: DeleteAttackListSenderSettingsPayload;
  deleteAuthzPolicy: DeleteAuthzPolicyPayload;
  /** プランナーの持つ設定一覧を返す */
  deleteAutoChatReplySetting: Array<AutoChatReplySetting>;
  deleteAutoChatReplySettings: DeleteAutoChatReplySettingsPayload;
  deleteCalendar: DeleteCalendarPayload;
  deleteChatMessageSendingJob: DeleteChatMessageSendingJobPayload;
  deleteChatMessageTemplate: Array<ChatMessageTemplate>;
  deleteChatRoomMemo: ChatRoom;
  /** 削除後にプランナーが持つすべての KartePlannerCommentTemplate を返す */
  deleteKartePlannerCommentTemplate: Array<KartePlannerCommentTemplate>;
  deleteLineRichMenu: DeleteLineRichMenuPayload;
  deleteNormalMessageChatReplyPlannerSetting: DeleteNormalMessageChatReplyPlannerSettingPayload;
  deleteScenarioChatV2: DeleteScenarioChatV2Payload;
  deleteSeminar: Scalars['Boolean']['output'];
  deleteSeminarSchedule: Seminar;
  deleteStaff: DeleteStaffPayload;
  deleteStepDelivery: DeleteStepDeliveryPayload;
  deleteTeam: DeleteTeamPayload;
  devCreateKollegeUserCourseLessons: Array<Scalars['ID']['output']>;
  /** ノーマルメッセージに対する自動応答を無効にする */
  disableNormalMessageChatReplyMatchSetting: DisableNormalMessageChatReplyMatchSettingPayload;
  /** ノーマルメッセージに対する自動応答を有効にする */
  enableNormalMessageChatReplyMatchSetting: EnableNormalMessageChatReplyMatchSettingPayload;
  for400FOA__completeUpload: Scalars['Boolean']['output'];
  for400FOA__issueFileDownloadURL: Scalars['String']['output'];
  for400FOA__issueSignedUploadURLs: For400FoaIssueSignedUploadUrlPayload;
  for400FOA__sendFileDownloadURL: For400FoaSendFileDownloadUrlPayload;
  generateStripeCreditCardSavingUrl: Scalars['String']['output'];
  issueChatMessageImageUploadUrl: IssueChatMessageImageUploadUrlPayload;
  /** 領収書の取得に使う */
  issueDownloadKollegeReceiptUrl: IssueDownloadKollegeReceiptUrlResponse;
  issueEnqueteAnswersCsvFileDownloadURL: IssueEnqueteAnswersCsvFileDownloadUrlPayload;
  issueLineRichMenuBackgroundImageUploadUrl: IssueLineRichMenuBackgroundImageUploadUrlPayload;
  issueLoginLinkURLFromCSV: IssueLoginLinkUrlFromCsvPayload;
  issueLoginLinkWithIDGeneration: IssueLoginLinkUrlWithIdGenerationPayload;
  issueMicrosoftOAuthURL: IssueMicrosoftOAuthUrlPayload;
  issuePlannerAvatarImageUploadUrl: IssuePlannerAvatarImageUploadUrlPayload;
  issuePlannerCoverImageUploadUrl: IssuePlannerCoverImageUploadUrlPayload;
  issueStaffAvatarImageUploadUrl: IssueStaffAvatarImageUploadUrlPayload;
  issueUploadKollegeReceiptUrl: IssueUploadKollegeReceiptUrlResponse;
  markAsAbsentedKollegeUserCourseLesson: KollegeUserCourseLesson;
  markAsCompletedKollegeUserCourseLesson: KollegeUserCourseLesson;
  postKartePlannerComment: PostKartePlannerCommentMutationPayload;
  previewAutoPostKartePlannerCommentSetting: PreviewAutoPostKartePlannerCommentSettingPayload;
  /** @deprecated previewKartePlannerComment queryを使ってください */
  previewKartePlannerComment: PreviewKartePlannerCommentPayload;
  previewKartePlannerCommentTemplate: PreviewKartePlannerCommentTemplatePayload;
  removeConditionalIntroductionMessage: RemoveConditionalIntroductionMessagePayload;
  removeUserVariableDefinitionValueSelectOption: RemoveUserVariableDefinitionValueSelectOptionPayload;
  requestChangePasswordWithoutLoggedIn: RequestChangePasswordWithoutLoggedInPayload;
  requestReview: Scalars['Unit']['output'];
  revokePlannerAccountThirdpartyOAuthCredentials: RevokePlannerAccountThirdpartyOAuthCredentialsPayload;
  rollbackCorporationAttackListSenderSettings: Scalars['Unit']['output'];
  saveDefaultIntroductionMessage: SaveDefaultIntroductionMessagePayload;
  saveNormalMessageChatReplyPlannerSetting: SaveNormalMessageChatReplyPlannerSettingPayload;
  saveScheduleAdjustmentDefaultCalendars: SaveScheduleAdjustmentDefaultCalendarsPayload;
  scheduleChatMessageSendingJob: ScheduleChatMessageSendingJobPayload;
  sendNormalChatMessage: SendNormalChatMessagePayload;
  sendNormalChatMessages: SendNormalChatMessagesPayload;
  sendQuestionChatMessage: SendQuestionChatMessagePayload;
  sendQuestionChatMessages: SendQuestionChatMessagesPayload;
  storePlannerAccountOAuthCredential: StorePlannerAccountOAuthCredentialPayload;
  unassignStaffFromMatch: UnassignStaffFromMatchPayload;
  updateAttackListSenderSetting: AttackListSenderSetting;
  updateAuthzPolicy: UpdateAuthzPolicyPayload;
  updateAutoChatReplySetting: UpdateAutoChatReplySettingPayload;
  updateAutoPostKartePlannerCommentSetting: AutoPostKartePlannerCommentSetting;
  updateCalendar: UpdateCalendarPayload;
  updateChatMessageTemplate: ChatMessageTemplate;
  /** 複数のチャットルームを指定のstatusに変更する */
  updateChatRoomsStatus: Array<ChatRoom>;
  /** 複数のチャットルームを指定のstatusに変更する。statusが未設定のものだけ。お気に入りと対応済みのlocalStorageからのマイグレーションにしか使わない */
  updateChatRoomsStatusByMatchIds?: Maybe<Array<ChatRoom>>;
  updateConditionalIntroductionMessage: UpdateConditionalIntroductionMessagePayload;
  updateContract: Contract;
  updateEnquete: UpdateEnquetePayload;
  updateKartePlannerCommentTemplate: KartePlannerCommentTemplate;
  updateKollegeExpenseRecordDailyLessonInstructorComment: KollegeExpenseRecordDailyLessonInput;
  updateKollegeUser?: Maybe<KollegeUser>;
  updateKollegeUserCourseInstructor?: Maybe<KollegeUserCourse>;
  updateKollegeUserInstructorMemo: UpdateKollegeUserInstructorMemoResponse;
  updateKollegeUserProfileAndAddress?: Maybe<UpdateKollegeUserProfileAndAddressResponse>;
  updateLineActivationProviderSetting: LineActivationProviderSetting;
  updateLineRichMenu: UpdateLineRichMenuPayload;
  updateLoginLinkRedirectURI: UpdateLoginLinkRedirectUriPayload;
  updatePlanner: Planner;
  updatePlannerBookingRequestCalendarSetting: UpdatePlannerBookingRequestCalendarSettingPayload;
  updatePlannerProfile: PlannerProfile;
  updateScenarioChat: UpdateScenarioChatPayload;
  updateScheduledTimeOfChatMessageSendingJob: UpdateScheduledTimeOfChatMessageSendingJobPayload;
  updateSeminarSchedule: Schedule;
  updateStaff: UpdateStaffPayload;
  updateStaffProfile: UpdateStaffProfilePayload;
  updateStatus?: Maybe<ChatRoom>;
  updateStepDelivery: UpdateStepDeliveryPayload;
  updateTeam: UpdateTeamPayload;
  updateUserRegistrationInflowSourceDefinition: UpdateUserRegistrationInflowSourceDefinitionPayload;
  updateUserVariableDefinition: UpdateUserVariableDefinitionPayload;
  updateUserVariableDefinitionValueSelectOption: UpdateUserVariableDefinitionValueSelectOptionPayload;
  verifyPasswordResetToken: VerifyPasswordResetTokenPayload;
};


export type MutationAddChatMessageTemplateArgs = {
  input: AddChatMessageTemplateInput;
};


export type MutationAddChatRoomMemoArgs = {
  chatRoomID: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type MutationAddKartePlannerCommentTemplateArgs = {
  input: AddKartePlannerCommentTemplateInput;
};


export type MutationAddUserVariableDefinitionValueSelectOptionArgs = {
  input: AddUserVariableDefinitionValueSelectOptionInput;
};


export type MutationAgreeTermsArgs = {
  termRevisionIDs: Array<Scalars['ID']['input']>;
};


export type MutationAssignStaffToMatchArgs = {
  input: AssignStaffToMatchInput;
};


export type MutationCancelBookingArgs = {
  cancelReason: BookingCancelReason;
  guid: Scalars['ID']['input'];
};


export type MutationCancelKollegeUserCourseArgs = {
  input: CancelKollegeUserCourse;
};


export type MutationChangePasswordWithLoggedInArgs = {
  password: Scalars['String']['input'];
};


export type MutationChangePasswordWithoutLoggedInArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCompleteKollegeUserTrialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteUploadKollegeReceiptArgs = {
  input: CompleteUploadKollegeReceiptInput;
};


export type MutationCopyAutoChatReplySettingsArgs = {
  dstPlannerIds: Array<Scalars['ID']['input']>;
  settingIdsAllowedToOverwrite: Array<Scalars['ID']['input']>;
  srcPlannerId: Scalars['ID']['input'];
  strategy: AutoChatReplySettingCopyStrategy;
};


export type MutationCreateAttackListSenderSettingArgs = {
  input: CreateAttackListSenderSettingInput;
};


export type MutationCreateAuthzPolicyArgs = {
  input: CreateAuthzPolicyInput;
};


export type MutationCreateAutoChatReplySettingArgs = {
  input: CreateAutoChatReplySettingInput;
};


export type MutationCreateCalendarArgs = {
  input: CreateCalendarInput;
};


export type MutationCreateConditionalIntroductionMessageArgs = {
  input: CreateConditionalIntroductionMessageInput;
};


export type MutationCreateCorporationAttackListSenderSettingsArgs = {
  input: CreateAttackListSenderSettingsInput;
};


export type MutationCreateEnqueteArgs = {
  input?: InputMaybe<CreateEnqueteInput>;
};


export type MutationCreateKollegeExpenseRecordDailyLessonArgs = {
  input: CreateKollegeExpenseRecordDailyLessonInput;
};


export type MutationCreateLineRichMenuArgs = {
  input: CreateLineRichMenuInput;
};


export type MutationCreateScenarioChatArgs = {
  input: CreateScenarioChatInput;
};


export type MutationCreateSeminarSchedulesArgs = {
  input: Array<SeminarScheduleInput>;
  seminarId: Scalars['ID']['input'];
};


export type MutationCreateStaffArgs = {
  input: CreateStaffInput;
};


export type MutationCreateStepDeliveryArgs = {
  input: CreateStepDeliveryInput;
};


export type MutationCreateTeamArgs = {
  input?: InputMaybe<CreateTeamInput>;
};


export type MutationCreateUserRegistrationInflowSourceDefinitionArgs = {
  input: CreateUserRegistrationInflowSourceDefinitionInput;
};


export type MutationCreateUserVariableDefinitionArgs = {
  input: CreateUserVariableDefinitionInput;
};


export type MutationDeleteAttackListSenderSettingsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAuthzPolicyArgs = {
  input: DeleteAuthzPolicyInput;
};


export type MutationDeleteAutoChatReplySettingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAutoChatReplySettingsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCalendarArgs = {
  input: DeleteCalendarInput;
};


export type MutationDeleteChatMessageSendingJobArgs = {
  input: DeleteChatMessageSendingJobInput;
};


export type MutationDeleteChatMessageTemplateArgs = {
  guid: Scalars['ID']['input'];
};


export type MutationDeleteChatRoomMemoArgs = {
  chatRoomMemoID: Scalars['ID']['input'];
};


export type MutationDeleteKartePlannerCommentTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLineRichMenuArgs = {
  guid: Scalars['ID']['input'];
};


export type MutationDeleteScenarioChatV2Args = {
  guid: Scalars['ID']['input'];
};


export type MutationDeleteSeminarArgs = {
  seminarId: Scalars['ID']['input'];
};


export type MutationDeleteSeminarScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
  seminarId: Scalars['ID']['input'];
};


export type MutationDeleteStaffArgs = {
  input: DeleteStaffInput;
};


export type MutationDeleteStepDeliveryArgs = {
  guid: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  input?: InputMaybe<DeleteTeamInput>;
};


export type MutationDevCreateKollegeUserCourseLessonsArgs = {
  userCourseGUIDStr: Scalars['ID']['input'];
};


export type MutationDisableNormalMessageChatReplyMatchSettingArgs = {
  input: DisableNormalMessageChatReplyMatchSettingInput;
};


export type MutationEnableNormalMessageChatReplyMatchSettingArgs = {
  input: EnableNormalMessageChatReplyMatchSettingInput;
};


export type MutationFor400Foa__CompleteUploadArgs = {
  chatRoomId: Scalars['ID']['input'];
  uploadRequestIds: Array<Scalars['ID']['input']>;
  uploadRequests?: InputMaybe<Array<InputMaybe<UploadRequestInput>>>;
};


export type MutationFor400Foa__IssueFileDownloadUrlArgs = {
  chatRoomFileId: Scalars['ID']['input'];
};


export type MutationFor400Foa__IssueSignedUploadUrLsArgs = {
  chatRoomId: Scalars['ID']['input'];
  files: Array<ChatRoomInputFile>;
};


export type MutationFor400Foa__SendFileDownloadUrlArgs = {
  chatRoomFileId: Scalars['ID']['input'];
};


export type MutationGenerateStripeCreditCardSavingUrlArgs = {
  cancelCallbackUrl: Scalars['String']['input'];
  successCallbackUrl: Scalars['String']['input'];
};


export type MutationIssueChatMessageImageUploadUrlArgs = {
  input: IssueChatMessageImageUploadUrlInput;
};


export type MutationIssueDownloadKollegeReceiptUrlArgs = {
  input: IssueDownloadKollegeReceiptUrlInput;
};


export type MutationIssueEnqueteAnswersCsvFileDownloadUrlArgs = {
  input: IssueEnqueteAnswersCsvFileDownloadUrlInput;
};


export type MutationIssueLineRichMenuBackgroundImageUploadUrlArgs = {
  input: IssueLineRichMenuBackgroundImageUploadUrlInput;
};


export type MutationIssueLoginLinkUrlFromCsvArgs = {
  input: IssueLoginLinkUrlFromCsvInput;
};


export type MutationIssueLoginLinkWithIdGenerationArgs = {
  input: IssueLoginLinkUrlWithIdGenerationInput;
};


export type MutationIssueMicrosoftOAuthUrlArgs = {
  redirectURL: Scalars['String']['input'];
};


export type MutationIssuePlannerAvatarImageUploadUrlArgs = {
  ext: Scalars['String']['input'];
};


export type MutationIssuePlannerCoverImageUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};


export type MutationIssueUploadKollegeReceiptUrlArgs = {
  input: IssueUploadKollegeReceiptUrlInput;
};


export type MutationMarkAsAbsentedKollegeUserCourseLessonArgs = {
  input: MarkAsAbsentedKollegeUserCourseLessonInput;
};


export type MutationMarkAsCompletedKollegeUserCourseLessonArgs = {
  input: MarkAsCompletedKollegeUserCourseLessonInput;
};


export type MutationPostKartePlannerCommentArgs = {
  comment: Scalars['String']['input'];
  karteID: Scalars['ID']['input'];
  selections?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPreviewAutoPostKartePlannerCommentSettingArgs = {
  setting: AutoPostKartePlannerCommentSettingInput;
};


export type MutationPreviewKartePlannerCommentArgs = {
  comment: Scalars['String']['input'];
  karteID: Scalars['ID']['input'];
  selections: Array<Scalars['String']['input']>;
};


export type MutationPreviewKartePlannerCommentTemplateArgs = {
  input: PreviewKartePlannerCommentTemplateInput;
};


export type MutationRemoveConditionalIntroductionMessageArgs = {
  input: RemoveConditionalIntroductionMessageInput;
};


export type MutationRemoveUserVariableDefinitionValueSelectOptionArgs = {
  input: RemoveUserVariableDefinitionValueSelectOptionInput;
};


export type MutationRequestChangePasswordWithoutLoggedInArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestReviewArgs = {
  roomId: Scalars['ID']['input'];
};


export type MutationRevokePlannerAccountThirdpartyOAuthCredentialsArgs = {
  input: RevokePlannerAccountThirdpartyOAuthCredentialsInput;
};


export type MutationRollbackCorporationAttackListSenderSettingsArgs = {
  targetRevisionId: Scalars['ID']['input'];
};


export type MutationSaveDefaultIntroductionMessageArgs = {
  input: SaveDefaultIntroductionMessageInput;
};


export type MutationSaveNormalMessageChatReplyPlannerSettingArgs = {
  input: SaveNormalMessageChatReplyPlannerSettingInput;
};


export type MutationSaveScheduleAdjustmentDefaultCalendarsArgs = {
  input?: InputMaybe<SaveScheduleAdjustmentDefaultCalendarsInput>;
};


export type MutationScheduleChatMessageSendingJobArgs = {
  input: ScheduleChatMessageSendingJobInput;
};


export type MutationSendNormalChatMessageArgs = {
  input: SendNormalChatMessageInput;
};


export type MutationSendNormalChatMessagesArgs = {
  input: SendNormalChatMessagesInput;
};


export type MutationSendQuestionChatMessageArgs = {
  input: SendQuestionChatMessageInput;
};


export type MutationSendQuestionChatMessagesArgs = {
  input: SendQuestionChatMessagesInput;
};


export type MutationStorePlannerAccountOAuthCredentialArgs = {
  input: StorePlannerAccountOAuthCredentialInput;
};


export type MutationUnassignStaffFromMatchArgs = {
  input: UnassignStaffFromMatchInput;
};


export type MutationUpdateAttackListSenderSettingArgs = {
  input: UpdateAttackListSenderSettingInput;
};


export type MutationUpdateAuthzPolicyArgs = {
  input: UpdateAuthzPolicyInput;
};


export type MutationUpdateAutoChatReplySettingArgs = {
  input: UpdateAutoChatReplySettingInput;
};


export type MutationUpdateAutoPostKartePlannerCommentSettingArgs = {
  setting: AutoPostKartePlannerCommentSettingInput;
};


export type MutationUpdateCalendarArgs = {
  input: UpdateCalendarInput;
};


export type MutationUpdateChatMessageTemplateArgs = {
  input: UpdateChatMessageTemplateInput;
};


export type MutationUpdateChatRoomsStatusArgs = {
  ids: Array<Scalars['ID']['input']>;
  status: ChatRoomStatus;
};


export type MutationUpdateChatRoomsStatusByMatchIdsArgs = {
  matchIds: Array<Scalars['ID']['input']>;
  status: ChatRoomStatus;
};


export type MutationUpdateConditionalIntroductionMessageArgs = {
  input: UpdateConditionalIntroductionMessageInput;
};


export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdateEnqueteArgs = {
  input?: InputMaybe<UpdateEnqueteInput>;
};


export type MutationUpdateKartePlannerCommentTemplateArgs = {
  input: UpdateKartePlannerCommentTemplateInput;
};


export type MutationUpdateKollegeExpenseRecordDailyLessonInstructorCommentArgs = {
  input: UpdateKollegeExpenseRecordDailyLessonInstructorCommentInput;
};


export type MutationUpdateKollegeUserArgs = {
  input: UpdateKollegeUserInput;
};


export type MutationUpdateKollegeUserCourseInstructorArgs = {
  input: UpdateKollegeUserCourseInstructor;
};


export type MutationUpdateKollegeUserInstructorMemoArgs = {
  input: UpdateKollegeUserInstructorMemoInput;
};


export type MutationUpdateKollegeUserProfileAndAddressArgs = {
  input: UpdateKollegeUserProfileAndAddressInput;
};


export type MutationUpdateLineActivationProviderSettingArgs = {
  input: UpdateLineActivationProviderSettingInput;
};


export type MutationUpdateLineRichMenuArgs = {
  input: UpdateLineRichMenuInput;
};


export type MutationUpdateLoginLinkRedirectUriArgs = {
  input: UpdateLoginLinkRedirectUriInput;
};


export type MutationUpdatePlannerArgs = {
  input: UpdatePlannerInput;
};


export type MutationUpdatePlannerBookingRequestCalendarSettingArgs = {
  input: UpdatePlannerBookingRequestCalendarSettingInput;
};


export type MutationUpdatePlannerProfileArgs = {
  input: UpdatePlannerProfileInput;
};


export type MutationUpdateScenarioChatArgs = {
  input: UpdateScenarioChatInput;
};


export type MutationUpdateScheduledTimeOfChatMessageSendingJobArgs = {
  input: UpdateScheduledTimeOfChatMessageSendingJobInput;
};


export type MutationUpdateSeminarScheduleArgs = {
  input: SeminarScheduleInput;
  scheduleId: Scalars['ID']['input'];
  seminarId: Scalars['ID']['input'];
};


export type MutationUpdateStaffArgs = {
  input: UpdateStaffInput;
};


export type MutationUpdateStaffProfileArgs = {
  input: UpdateStaffProfileInput;
};


export type MutationUpdateStatusArgs = {
  id: Scalars['ID']['input'];
  status: ChatRoomStatus;
};


export type MutationUpdateStepDeliveryArgs = {
  input: UpdateStepDeliveryInput;
};


export type MutationUpdateTeamArgs = {
  input?: InputMaybe<UpdateTeamInput>;
};


export type MutationUpdateUserRegistrationInflowSourceDefinitionArgs = {
  input: UpdateUserRegistrationInflowSourceDefinitionInput;
};


export type MutationUpdateUserVariableDefinitionArgs = {
  input: UpdateUserVariableDefinitionInput;
};


export type MutationUpdateUserVariableDefinitionValueSelectOptionArgs = {
  input: UpdateUserVariableDefinitionValueSelectOptionInput;
};


export type MutationVerifyPasswordResetTokenArgs = {
  token: Scalars['String']['input'];
};

export type NewsForPlanner = {
  __typename?: 'NewsForPlanner';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['Time']['output'];
  title: Scalars['String']['output'];
};

export type NewsForPlannerConnection = {
  __typename?: 'NewsForPlannerConnection';
  edges: Array<NewsForPlannerEdge>;
  pageInfo: NewsForPlannerPageInfo;
};

export type NewsForPlannerEdge = {
  __typename?: 'NewsForPlannerEdge';
  cursor: Scalars['String']['output'];
  node: NewsForPlanner;
};

export type NewsForPlannerPageInfo = {
  __typename?: 'NewsForPlannerPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type NormalChatMessagePreview = {
  __typename?: 'NormalChatMessagePreview';
  message: Scalars['String']['output'];
};

/** ノーマルメッセージに対する自動応答のマッチごとの設定 */
export type NormalMessageChatReplyMatchSetting = {
  __typename?: 'NormalMessageChatReplyMatchSetting';
  /** ここで指定した日時までノーマルメッセージに対する自動応答が無効になる */
  disabledUntil?: Maybe<Scalars['Time']['output']>;
};

export type NormalMessageChatReplyPlannerSetting = {
  __typename?: 'NormalMessageChatReplyPlannerSetting';
  guid: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type NullableBoolean = {
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableInt = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableKollegeSakugenkahi = {
  value?: InputMaybe<KollegeSakugenkahi>;
};

export type NullableString = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export const OAuthProvider = {
  Google: 'GOOGLE',
  Microsoft: 'MICROSOFT'
} as const;

export type OAuthProvider = typeof OAuthProvider[keyof typeof OAuthProvider];
export type OffsetBasedPageInfo = {
  __typename?: 'OffsetBasedPageInfo';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OkanentClient = {
  __typename?: 'OkanentClient';
  id: Scalars['ID']['output'];
};

export type OkanentClientUser = {
  __typename?: 'OkanentClientUser';
  foreignUserID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  okanentClient: OkanentClient;
  user: User;
};

export type OkanentClientUserConnection = {
  __typename?: 'OkanentClientUserConnection';
  edges: Array<OkanentClientUserEdge>;
  pageInfo: PageInfo;
};

export type OkanentClientUserEdge = {
  __typename?: 'OkanentClientUserEdge';
  cursor: Scalars['String']['output'];
  node: OkanentClientUser;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export const PaymentMethod = {
  Stripe: 'STRIPE',
  Unknown: 'UNKNOWN'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];
export type Personality = {
  __typename?: 'Personality';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: PersonalityType;
};

export const PersonalityType = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H'
} as const;

export type PersonalityType = typeof PersonalityType[keyof typeof PersonalityType];
export type PlainIntroductionMessageContent = {
  __typename?: 'PlainIntroductionMessageContent';
  body: Scalars['String']['output'];
  selections: Array<Scalars['String']['output']>;
};

export type PlainIntroductionMessageInput = {
  body: Scalars['String']['input'];
  /** 初期チャットメッセージは選択肢なしもあるので、選択肢を消したい・入れたくないときはselectionsに空配列を入れる */
  selections: Array<Scalars['String']['input']>;
};

export const Plan = {
  /** V2021_1 エンタープライズプラン */
  V2021_1Enterprise: 'V2021_1Enterprise',
  /** V2021_1 プレミアムプラン */
  V2021_1Premium: 'V2021_1Premium',
  /** V2021_1 スタンダードプラン */
  V2021_1Standard: 'V2021_1Standard',
  /** V2022_1 Enterpriseプラン */
  V2022_1Enterprise: 'V2022_1Enterprise',
  /** V2022_1 Entryプラン */
  V2022_1Entry: 'V2022_1Entry',
  /** V2022_1 PRプラン */
  V2022_1Pr: 'V2022_1PR',
  /** V2022_1 Proプラン */
  V2022_1Pro: 'V2022_1Pro',
  /** V2022_2 管理者専用無料プラン */
  V2022_2ManageOnlyFree: 'V2022_2ManageOnlyFree',
  /** V2023_1 エンタープライズプラン */
  V2023_1Enterprise: 'V2023_1Enterprise',
  /** V2023_1 エキスパートプラン */
  V2023_1Expert: 'V2023_1Expert',
  /** V2023_1 管理者専用無料プラン */
  V2023_1ManageOnlyFree: 'V2023_1ManageOnlyFree',
  /** V2023_1 マスタープラン */
  V2023_1Master: 'V2023_1Master',
  /** V2023_1 スキルフォースプラン */
  V2023_1SkillForce: 'V2023_1SkillForce'
} as const;

export type Plan = typeof Plan[keyof typeof Plan];
export type Planner = {
  __typename?: 'Planner';
  authorities: Array<Scalars['String']['output']>;
  autoChatReplySettings: Array<AutoChatReplySetting>;
  availableAreaCodes: Array<Scalars['String']['output']>;
  availableTime: Scalars['String']['output'];
  avatar?: Maybe<Scalars['ImagePath']['output']>;
  avatarUrl: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  branchIds: Array<Scalars['ID']['output']>;
  chatParticipant?: Maybe<ChatParticipant>;
  comment: Scalars['String']['output'];
  corporationId: Scalars['ID']['output'];
  cover?: Maybe<Scalars['ImagePath']['output']>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  specialties: Array<PlannerSpecialty>;
};

export type PlannerBookingRequestCalendarSetting = {
  __typename?: 'PlannerBookingRequestCalendarSetting';
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
};

export type PlannerProfile = {
  __typename?: 'PlannerProfile';
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['ImagePath']['output']>;
  childrenState: ChildrenState;
  comment: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reviewScore: Scalars['Float']['output'];
};

export type PlannerSpecialty = {
  __typename?: 'PlannerSpecialty';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PostKartePlannerCommentMutationErrorPayload = {
  __typename?: 'PostKartePlannerCommentMutationErrorPayload';
  error: KartePlannerCommentUnavailableReason;
};

export type PostKartePlannerCommentMutationPayload = PostKartePlannerCommentMutationErrorPayload | PostKartePlannerCommentMutationSuccessPayload;

export type PostKartePlannerCommentMutationSuccessPayload = {
  __typename?: 'PostKartePlannerCommentMutationSuccessPayload';
  karte: Karte;
  viewer: Viewer;
};

export const Prefecture = {
  Aichi: 'Aichi',
  Akita: 'Akita',
  Aomori: 'Aomori',
  Chiba: 'Chiba',
  Ehime: 'Ehime',
  Fukui: 'Fukui',
  Fukuoka: 'Fukuoka',
  Fukushima: 'Fukushima',
  Gifu: 'Gifu',
  Gunma: 'Gunma',
  Hiroshima: 'Hiroshima',
  Hokkaido: 'Hokkaido',
  Hyogo: 'Hyogo',
  Ibaraki: 'Ibaraki',
  Ishikawa: 'Ishikawa',
  Iwate: 'Iwate',
  Kagawa: 'Kagawa',
  Kagoshima: 'Kagoshima',
  Kanagawa: 'Kanagawa',
  Kochi: 'Kochi',
  Kumamoto: 'Kumamoto',
  Kyoto: 'Kyoto',
  Mie: 'Mie',
  Miyagi: 'Miyagi',
  Miyazaki: 'Miyazaki',
  Nagano: 'Nagano',
  Nagasaki: 'Nagasaki',
  Nara: 'Nara',
  Niigata: 'Niigata',
  Oita: 'Oita',
  Okayama: 'Okayama',
  Okinawa: 'Okinawa',
  Osaka: 'Osaka',
  Saga: 'Saga',
  Saitama: 'Saitama',
  Shiga: 'Shiga',
  Shimane: 'Shimane',
  Shizuoka: 'Shizuoka',
  Tochigi: 'Tochigi',
  Tokushima: 'Tokushima',
  Tokyo: 'Tokyo',
  Tottori: 'Tottori',
  Toyama: 'Toyama',
  Wakayama: 'Wakayama',
  Yamagata: 'Yamagata',
  Yamaguchi: 'Yamaguchi',
  Yamanashi: 'Yamanashi'
} as const;

export type Prefecture = typeof Prefecture[keyof typeof Prefecture];
export type PreviewAutoPostKartePlannerCommentSettingPayload = {
  __typename?: 'PreviewAutoPostKartePlannerCommentSettingPayload';
  maybeUserNames: Array<Scalars['String']['output']>;
};

export type PreviewKartePlannerCommentPayload = {
  __typename?: 'PreviewKartePlannerCommentPayload';
  maybeOtherUserNames: Array<Scalars['String']['output']>;
  preview: KartePlannerCommentPreview;
};

export type PreviewKartePlannerCommentTemplateInput = {
  body: Scalars['String']['input'];
  label: Scalars['String']['input'];
  selections: Array<Scalars['String']['input']>;
};

export type PreviewKartePlannerCommentTemplatePayload = {
  __typename?: 'PreviewKartePlannerCommentTemplatePayload';
  maybeUserNames: Array<Scalars['String']['output']>;
};

export type PreviewNormalChatMessagePayload = {
  __typename?: 'PreviewNormalChatMessagePayload';
  maybeOtherUserNames: Array<Scalars['String']['output']>;
  preview: NormalChatMessagePreview;
};

export type PreviewQuestionChatMessagePayload = {
  __typename?: 'PreviewQuestionChatMessagePayload';
  maybeOtherUserNames: Array<Scalars['String']['output']>;
  preview: QuestionChatMessagePreview;
};

export type Query = {
  __typename?: 'Query';
  assignedChatRooms?: Maybe<ChatRoomConnection>;
  attackListSenderSetting: AttackListSenderSetting;
  authzPolicies: Array<AuthzPolicy>;
  authzPolicy: AuthzPolicy;
  autoChatReplySetting: AutoChatReplySetting;
  availableBookingRequestTimeSlots: AvailableBookingRequestTimeSlotsPayload;
  booking?: Maybe<Booking>;
  /** @deprecated Use `booking` instead. */
  bookingByGUID?: Maybe<Booking>;
  /** @deprecated Use `calendarDetail.bookings` instead. */
  bookingsByCalendarGUID: BookingConnection;
  calendarDetail: Calendar;
  chatMessageSendingJob?: Maybe<ChatMessageSendingJob>;
  chatMessageSendingJobs: ChatMessageSendingJobConnection;
  chatMessageTemplate: ChatMessageTemplate;
  chatRoomFile: ChatRoomFile;
  /** 最終更新日時順（最新のメッセージが送られた日時）で返す */
  chatRooms?: Maybe<ChatRoomConnection>;
  chatRoomsByIDs: Array<ChatRoom>;
  colleagueChatRoom?: Maybe<ChatRoom>;
  colleagueChatRooms?: Maybe<ChatRoomConnection>;
  conditionalIntroductionMessage: ConditionalIntroductionMessage;
  conflictsOfAutoChatReplySettingsBetweenSrcAndDst: Array<AutoChatReplySettingCopyConflict>;
  contract?: Maybe<Contract>;
  corporation: Corporation;
  corporationAttackListSenderSettingRevisions: Array<AttackListSenderSettingRevision>;
  creatableStaffRoles: Array<Scalars['String']['output']>;
  currentEntrance: Entrance;
  diagnosis: Diagnosis;
  diagnosisByKarte: DiagnosisByKarte;
  diagnosisByUser: DiagnosisByUser;
  enquete: EnquetePayload;
  enquetes: EnquetesPayload;
  /** @deprecated Use `currentEntrance.calendarSummaries` instead. */
  entranceCalendarSummaries: Array<CalendarSummary>;
  entrances: Array<Entrance>;
  getCitiesByPrefecture: Array<City>;
  introductionMessageSetting: IntroductionMessageSetting;
  karte: Karte;
  karten: KarteConnection;
  kollegeInstructors: Array<KollegeInstructor>;
  kollegeUser?: Maybe<KollegeUser>;
  kollegeUsers: KollegeUserConnection;
  lineActivationProviderLiffAppConfig?: Maybe<LineActivationProviderLiffAppConfig>;
  lineActivationProviderSetting?: Maybe<LineActivationProviderSetting>;
  lineMessagingCurrentMonthQuota: LineMessagingCurrentMonthQuotaPayload;
  lineRichMenu: LineRichMenuPayload;
  lineRichMenus: ListLineRichMenuPayload;
  matchStatusesInSameBranch: MatchStatusesInSameBranchPayload;
  matchStatusesInSameCorporation: MatchStatusesInSameCorporationPayload;
  newsForPlanner: NewsForPlannerConnection;
  newsForPlannerById: NewsForPlanner;
  normalMessageChatReplyPlannerSetting?: Maybe<NormalMessageChatReplyPlannerSetting>;
  okanentClientUsers: OkanentClientUserConnection;
  okanentClientUsersForForeignUser: OkanentClientUserConnection;
  ownChatRoom?: Maybe<ChatRoom>;
  planner?: Maybe<Planner>;
  /** @deprecated Use `entranceCalendarSummaries` instead. */
  plannerCalendarSummaries: Array<CalendarSummary>;
  plannersInSameBranch: Array<Planner>;
  plannersInSameCorporation: Array<Planner>;
  previewKartePlannerComment: PreviewKartePlannerCommentPayload;
  previewNormalChatMessage: PreviewNormalChatMessagePayload;
  previewQuestionChatMessage: PreviewQuestionChatMessagePayload;
  review?: Maybe<Review>;
  scenarioChat: ScenarioChatPayload;
  scenarioChats: ScenarioChatsPayload;
  scheduleAdjustmentDefaultCalendars: Array<ScheduleAdjustmentDefaultCalendar>;
  searchSolicitorCloudCoverages: Array<SolicitorCloudCoverageDocumentSearchResult>;
  segmentConditionParameters: SegmentConditionParameters;
  /** viewer がホストであるセミナーのすべてを返す（過去分、未来分も含む） */
  seminars: Array<Seminar>;
  solicitorCloudCorporations: Array<SolicitorCloudCorporation>;
  solicitorCloudCoverageDocumentVersionByIds: Array<SolicitorCloudCoverageDocumentVersion>;
  solicitorCloudPamphletDocumentVersionByIds: Array<SolicitorCloudPamphletDocumentVersion>;
  solicitorCloudSalesMaterials: Array<SolicitorCloudSalesMaterial>;
  solicitorCloudSalesMaterialsByIds: Array<SolicitorCloudSalesMaterial>;
  specialties: Array<PlannerSpecialty>;
  staff: Staff;
  staffsByPlanner: Array<Staff>;
  stepDeliveries: Array<StepDelivery>;
  stepDelivery: StepDelivery;
  team: Team;
  teams: Array<Team>;
  term: TermRevision;
  terms: Array<TermRevision>;
  uiControl: UiControl;
  user: User;
  userRegistrationInflowSourceDefinition: UserRegistrationInflowSourceDefinition;
  userRegistrationInflowSourceDefinitions: Array<UserRegistrationInflowSourceDefinition>;
  userVariableDefinition: UserVariableDefinition;
  userVariableDefinitions: Array<UserVariableDefinition>;
  viewer: Viewer;
};


export type QueryAssignedChatRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ChatRoomFilterInput>;
  first: Scalars['Int']['input'];
};


export type QueryAttackListSenderSettingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthzPolicyArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryAutoChatReplySettingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAvailableBookingRequestTimeSlotsArgs = {
  from: Scalars['Time']['input'];
  until: Scalars['Time']['input'];
};


export type QueryBookingArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryBookingByGuidArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryBookingsByCalendarGuidArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Uint']['input'];
  guid: Scalars['ID']['input'];
};


export type QueryCalendarDetailArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryChatMessageSendingJobArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryChatMessageSendingJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryChatMessageTemplateArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryChatRoomFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ChatRoomFilterInput>;
  first: Scalars['Int']['input'];
};


export type QueryChatRoomsByIDsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryColleagueChatRoomArgs = {
  id: Scalars['ID']['input'];
};


export type QueryColleagueChatRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryConditionalIntroductionMessageArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryConflictsOfAutoChatReplySettingsBetweenSrcAndDstArgs = {
  dstPlannerIds: Array<Scalars['ID']['input']>;
  srcPlannerId: Scalars['ID']['input'];
  strategy: AutoChatReplySettingCopyStrategy;
};


export type QueryCorporationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiagnosisArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryDiagnosisByKarteArgs = {
  karteId: Scalars['ID']['input'];
};


export type QueryDiagnosisByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryEnqueteArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryEnquetesArgs = {
  input: EnquetesInput;
};


export type QueryGetCitiesByPrefectureArgs = {
  prefecture: Prefecture;
};


export type QueryKarteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKartenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<KartenFilter>;
  first: Scalars['Int']['input'];
  sortedBy?: InputMaybe<SortKey>;
};


export type QueryKollegeUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKollegeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<KollegeUsersFilterConditions>;
  first: Scalars['Int']['input'];
};


export type QueryLineRichMenuArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryMatchStatusesInSameBranchArgs = {
  since: Scalars['Date']['input'];
  until: Scalars['Date']['input'];
};


export type QueryMatchStatusesInSameCorporationArgs = {
  since: Scalars['Date']['input'];
  until: Scalars['Date']['input'];
};


export type QueryNewsForPlannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryNewsForPlannerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOkanentClientUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryOkanentClientUsersForForeignUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryOwnChatRoomArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPreviewKartePlannerCommentArgs = {
  comment: Scalars['String']['input'];
  karteID: Scalars['ID']['input'];
  selections: Array<Scalars['String']['input']>;
};


export type QueryPreviewNormalChatMessageArgs = {
  input: SendNormalChatMessageInput;
};


export type QueryPreviewQuestionChatMessageArgs = {
  input: SendQuestionChatMessageInput;
};


export type QueryReviewArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryScenarioChatArgs = {
  guid: Scalars['ID']['input'];
};


export type QuerySearchSolicitorCloudCoveragesArgs = {
  text: Scalars['String']['input'];
};


export type QuerySolicitorCloudCoverageDocumentVersionByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySolicitorCloudPamphletDocumentVersionByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySolicitorCloudSalesMaterialsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryStaffArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryStepDeliveryArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryTeamArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryTermArgs = {
  type: TermType;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserRegistrationInflowSourceDefinitionArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryUserVariableDefinitionArgs = {
  guid: Scalars['ID']['input'];
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answer: Scalars['String']['output'];
  questionText: Scalars['String']['output'];
};

export type QuestionChatMessagePreview = {
  __typename?: 'QuestionChatMessagePreview';
  message: Scalars['String']['output'];
  selections: Array<Scalars['String']['output']>;
};

export const RankInCluster = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  Unspecified: 'UNSPECIFIED'
} as const;

export type RankInCluster = typeof RankInCluster[keyof typeof RankInCluster];
export type ReadRoomAuthzPolicyAction = {
  __typename?: 'ReadRoomAuthzPolicyAction';
  isAssigned: Scalars['Boolean']['output'];
};

export type ReadRoomAuthzPolicyActionInput = {
  isAssigned: Scalars['Boolean']['input'];
};

export type RemoveConditionalIntroductionMessageInput = {
  guid: Scalars['ID']['input'];
};

export type RemoveConditionalIntroductionMessagePayload = SaveIntroductionMessageSuccess;

export const RemoveUserVariableDefinitionValueSelectOptionError = {
  /** すでに使用されているため削除できない */
  AlreadyUsed: 'ALREADY_USED',
  Unknown: 'UNKNOWN'
} as const;

export type RemoveUserVariableDefinitionValueSelectOptionError = typeof RemoveUserVariableDefinitionValueSelectOptionError[keyof typeof RemoveUserVariableDefinitionValueSelectOptionError];
export type RemoveUserVariableDefinitionValueSelectOptionErrorPayload = {
  __typename?: 'RemoveUserVariableDefinitionValueSelectOptionErrorPayload';
  error: RemoveUserVariableDefinitionValueSelectOptionError;
};

export type RemoveUserVariableDefinitionValueSelectOptionInput = {
  selectOptionGUID: Scalars['ID']['input'];
  userVariableDefinitionGUID: Scalars['ID']['input'];
};

export type RemoveUserVariableDefinitionValueSelectOptionPayload = RemoveUserVariableDefinitionValueSelectOptionErrorPayload | RemoveUserVariableDefinitionValueSelectOptionSuccessPayload;

export type RemoveUserVariableDefinitionValueSelectOptionSuccessPayload = {
  __typename?: 'RemoveUserVariableDefinitionValueSelectOptionSuccessPayload';
  void: Scalars['Void']['output'];
};

export type RequestChangePasswordWithoutLoggedInPayload = {
  __typename?: 'RequestChangePasswordWithoutLoggedInPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Review = {
  __typename?: 'Review';
  createdAt: Scalars['Time']['output'];
  entranceGUID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  plannerId: Scalars['ID']['output'];
  review: Scalars['String']['output'];
  reviewedAt?: Maybe<Scalars['Time']['output']>;
  score: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userId: Scalars['ID']['output'];
  userNickname: Scalars['String']['output'];
};

export type RevokePlannerAccountThirdpartyOAuthCredentialsInput = {
  provider: OAuthProvider;
};

export type RevokePlannerAccountThirdpartyOAuthCredentialsPayload = RevokePlannerAccountThirdpartyOAuthCredentialsSuccessPayload;

export type RevokePlannerAccountThirdpartyOAuthCredentialsSuccessPayload = {
  __typename?: 'RevokePlannerAccountThirdpartyOAuthCredentialsSuccessPayload';
  unit: Scalars['Unit']['output'];
};

export type RoomAuthzPolicyResource = {
  __typename?: 'RoomAuthzPolicyResource';
  roomID: Scalars['ID']['output'];
};

export type RoomAuthzPolicyResourceInput = {
  roomID: Scalars['ID']['input'];
};

export type SaveAutoChatReplySettingSuccess = {
  __typename?: 'SaveAutoChatReplySettingSuccess';
  autoChatReplySetting: AutoChatReplySetting;
};

export type SaveDefaultIntroductionMessageInput = {
  content: IntroductionMessageContentInput;
};

export type SaveDefaultIntroductionMessagePayload = SaveIntroductionMessageSuccess;

export type SaveIntroductionMessageSuccess = {
  __typename?: 'SaveIntroductionMessageSuccess';
  setting: IntroductionMessageSetting;
};

export type SaveNormalMessageChatReplyPlannerSettingInput = {
  isEnabled: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
};

export type SaveNormalMessageChatReplyPlannerSettingPayload = {
  __typename?: 'SaveNormalMessageChatReplyPlannerSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type SaveScheduleAdjustmentDefaultCalendarsInput = {
  ScheduleAdjustmentDefaultCalendars: Array<ScheduleAdjustmentDefaultCalendarInput>;
};

export type SaveScheduleAdjustmentDefaultCalendarsPayload = {
  __typename?: 'SaveScheduleAdjustmentDefaultCalendarsPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type ScenarioChat = {
  __typename?: 'ScenarioChat';
  guid: Scalars['ID']['output'];
  /** index:0が開始メッセージ */
  messages: Array<ScenarioChatMessage>;
  title: Scalars['String']['output'];
};

export type ScenarioChatIntroductionMessageContent = {
  __typename?: 'ScenarioChatIntroductionMessageContent';
  scenarioChatGuid: Scalars['ID']['output'];
};

export type ScenarioChatIntroductionMessageInput = {
  scenarioChatGuid: Scalars['ID']['input'];
};

export type ScenarioChatMessage = {
  __typename?: 'ScenarioChatMessage';
  body: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  selections: Array<ScenarioChatMessageSelection>;
  /** selectionsが空の場合は終了メッセージ */
  selectionsV2?: Maybe<ScenarioChatMessageSelections>;
};

export type ScenarioChatMessageBasicSelection = {
  __typename?: 'ScenarioChatMessageBasicSelection';
  actions: Array<ScenarioChatMessageSelectionAction>;
  guid: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nextMessageIndex?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioChatMessageBasicSelectionInput = {
  actions: Array<ScenarioChatMessageSelectionActionInput>;
  guid?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  nextMessageIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioChatMessageBasicSelections = {
  __typename?: 'ScenarioChatMessageBasicSelections';
  basicSelections: Array<ScenarioChatMessageBasicSelection>;
};

export type ScenarioChatMessageBookingRequestSelections = {
  __typename?: 'ScenarioChatMessageBookingRequestSelections';
  fallbackUrl?: Maybe<Scalars['String']['output']>;
};

export type ScenarioChatMessageBookingRequestSelectionsInput = {
  fallbackUrl?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Scalars['ID']['input']>;
};

export type ScenarioChatMessageInput = {
  body: Scalars['String']['input'];
  guid?: InputMaybe<Scalars['ID']['input']>;
  selections: Array<ScenarioChatMessageSelectionInput>;
  selectionsV2?: InputMaybe<ScenarioChatMessageSelectionsInput>;
};

export type ScenarioChatMessageSelection = {
  __typename?: 'ScenarioChatMessageSelection';
  actions: Array<ScenarioChatMessageSelectionAction>;
  guid: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nextMessageIndex?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioChatMessageSelectionAction = ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch;

export type ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch = {
  __typename?: 'ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch';
  assignedStaffGUID: Scalars['ID']['output'];
  guid: Scalars['ID']['output'];
};

export type ScenarioChatMessageSelectionActionInput = {
  /** oneof */
  assignPlannerAccountToMatch?: InputMaybe<ScrnarioChatMessageSelectionActionAssignPlannerAccountToMatchInput>;
};

export type ScenarioChatMessageSelectionInput = {
  actions: Array<ScenarioChatMessageSelectionActionInput>;
  guid?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  nextMessageIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioChatMessageSelections = ScenarioChatMessageBasicSelections | ScenarioChatMessageBookingRequestSelections;

export type ScenarioChatMessageSelectionsInput = {
  /** oneof */
  basicSelections?: InputMaybe<Array<ScenarioChatMessageBasicSelectionInput>>;
  bookingRequestSelections?: InputMaybe<ScenarioChatMessageBookingRequestSelectionsInput>;
};

export type ScenarioChatPayload = {
  __typename?: 'ScenarioChatPayload';
  scenarioChat: ScenarioChat;
};

export type ScenarioChatsPayload = {
  __typename?: 'ScenarioChatsPayload';
  scenarioChats: Array<ScenarioChat>;
};

export type Schedule = {
  __typename?: 'Schedule';
  applicantCount: Scalars['Uint']['output'];
  applicationDue: Scalars['Time']['output'];
  capacity?: Maybe<Scalars['Uint']['output']>;
  endedAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isOnline: Scalars['Boolean']['output'];
  isReachedCapacity: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  startedAt: Scalars['Time']['output'];
};

export type ScheduleAdjustmentDefaultCalendar = {
  __typename?: 'ScheduleAdjustmentDefaultCalendar';
  CalendarGUID: Scalars['ID']['output'];
  ScheduleAdjustmentVariant: ScheduleAdjustmentVariant;
};

export type ScheduleAdjustmentDefaultCalendarInput = {
  CalendarGUID: Scalars['ID']['input'];
  ScheduleAdjustmentVariant: ScheduleAdjustmentVariant;
};

export const ScheduleAdjustmentVariant = {
  AutoChatReply: 'AUTO_CHAT_REPLY',
  Default: 'DEFAULT',
  ScenarioChat: 'SCENARIO_CHAT'
} as const;

export type ScheduleAdjustmentVariant = typeof ScheduleAdjustmentVariant[keyof typeof ScheduleAdjustmentVariant];
export type ScheduleChatMessageSendingJobErrorPayload = {
  __typename?: 'ScheduleChatMessageSendingJobErrorPayload';
  reason: Scalars['String']['output'];
};

export type ScheduleChatMessageSendingJobInput = {
  messages: Array<ScheduleChatMessageSendingJobInputMessage>;
  scheduledAt?: InputMaybe<Scalars['Time']['input']>;
  target: ScheduleChatMessageSendingJobInputTarget;
};

export type ScheduleChatMessageSendingJobInputImageMessage = {
  altText: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  linkUri: Scalars['String']['input'];
};

export type ScheduleChatMessageSendingJobInputMessage = {
  imageMessage?: InputMaybe<ScheduleChatMessageSendingJobInputImageMessage>;
  textMessage?: InputMaybe<ScheduleChatMessageSendingJobInputTextMessage>;
};

export type ScheduleChatMessageSendingJobInputTarget = {
  allUsers?: InputMaybe<Scalars['Void']['input']>;
  segmentUsers?: InputMaybe<ScheduleChatMessageSendingJobInputTargetSegmentUsers>;
  targetUsers?: InputMaybe<ScheduleChatMessageSendingJobInputTargetTargetUsers>;
};

export type ScheduleChatMessageSendingJobInputTargetSegmentUsers = {
  segment: SegmentInput;
};

export type ScheduleChatMessageSendingJobInputTargetTargetUsers = {
  okanentClientUserIds: Array<Scalars['String']['input']>;
};

export type ScheduleChatMessageSendingJobInputTextMessage = {
  selections: Array<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type ScheduleChatMessageSendingJobPayload = ScheduleChatMessageSendingJobErrorPayload | ScheduleChatMessageSendingJobSuccessPayload;

export type ScheduleChatMessageSendingJobSuccessPayload = {
  __typename?: 'ScheduleChatMessageSendingJobSuccessPayload';
  jobGuid?: Maybe<Scalars['ID']['output']>;
};

export type ScrnarioChatMessageSelectionActionAssignPlannerAccountToMatchInput = {
  assignedPlannerAccountId?: InputMaybe<Scalars['ID']['input']>;
  assignedStaffGUID: Scalars['ID']['input'];
  guid?: InputMaybe<Scalars['ID']['input']>;
};

export type Segment = {
  __typename?: 'Segment';
  conditions: Array<Condition>;
};

export type SegmentConditionClickUrlCondition = {
  __typename?: 'SegmentConditionClickURLCondition';
  not: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type SegmentConditionClickUrlConditionInput = {
  not: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};

export type SegmentConditionEnqueteAnswered = {
  __typename?: 'SegmentConditionEnqueteAnswered';
  enqueteGUID: Scalars['String']['output'];
  not: Scalars['Boolean']['output'];
};

export type SegmentConditionEnqueteAnsweredInput = {
  enqueteGUID: Scalars['String']['input'];
  not: Scalars['Boolean']['input'];
};

export type SegmentConditionInflowSource = {
  __typename?: 'SegmentConditionInflowSource';
  inflowSourceDefinitionGUID: Scalars['String']['output'];
  not: Scalars['Boolean']['output'];
};

export type SegmentConditionInflowSourceInput = {
  inflowSourceDefinitionGUID: Scalars['String']['input'];
  not: Scalars['Boolean']['input'];
};

export type SegmentConditionLoginLink = {
  __typename?: 'SegmentConditionLoginLink';
  not: Scalars['Boolean']['output'];
};

export type SegmentConditionLoginLinkInput = {
  not: Scalars['Boolean']['input'];
};

export type SegmentConditionParameter_ClickUrl = {
  __typename?: 'SegmentConditionParameter_ClickURL';
  clickUrls: Array<SegmentConditionParameter_ClickUrl_Url>;
};

export type SegmentConditionParameter_ClickUrl_Url = {
  __typename?: 'SegmentConditionParameter_ClickURL_URL';
  guid: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SegmentConditionParameter_EnqueteAnswered = {
  __typename?: 'SegmentConditionParameter_EnqueteAnswered';
  enquetes: Array<SegmentConditionParameter_EnqueteAnswered_Enquete>;
};

export type SegmentConditionParameter_EnqueteAnswered_Enquete = {
  __typename?: 'SegmentConditionParameter_EnqueteAnswered_Enquete';
  guid: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SegmentConditionParameter_InflowSource = {
  __typename?: 'SegmentConditionParameter_InflowSource';
  inflowSources: Array<UserRegistrationInflowSourceDefinition>;
};

export type SegmentConditionParameter_UserVariableDefinition = {
  __typename?: 'SegmentConditionParameter_UserVariableDefinition';
  userVariableDefinitions: Array<UserVariableDefinition>;
};

export type SegmentConditionParameters = {
  __typename?: 'SegmentConditionParameters';
  clickURLCondition: SegmentConditionParameter_ClickUrl;
  enqueteAnsweredCondition: SegmentConditionParameter_EnqueteAnswered;
  inflowSourceCondition: SegmentConditionParameter_InflowSource;
  userVariableDefinitionCondition: SegmentConditionParameter_UserVariableDefinition;
};

export type SegmentConditionRoomStatus = {
  __typename?: 'SegmentConditionRoomStatus';
  not: Scalars['Boolean']['output'];
  status: ChatRoomStatus;
};

export type SegmentConditionRoomStatusInput = {
  not: Scalars['Boolean']['input'];
  status: ChatRoomStatus;
};

export type SegmentConditionUserVariableDefinitionInput = {
  definitionGUID: Scalars['ID']['input'];
  not: Scalars['Boolean']['input'];
  values: Array<Scalars['ID']['input']>;
};

export type SegmentInput = {
  conditions: Array<ConditionInput>;
};

export type Seminar = {
  __typename?: 'Seminar';
  applicantFee: Scalars['String']['output'];
  applicantsDescription: Scalars['String']['output'];
  applicationFee: Scalars['Uint']['output'];
  attention?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schedules: Array<Schedule>;
  sponsor: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SeminarScheduleInput = {
  applicationDue: Scalars['Time']['input'];
  capacity?: InputMaybe<Scalars['Uint']['input']>;
  endedAt: Scalars['Time']['input'];
  isOnline: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  startedAt: Scalars['Time']['input'];
};

export type SendChatMessageAttachmentInput = {
  /** JSON 文字列 */
  rawContent: Scalars['String']['input'];
  type: ChatMessageAttachmentType;
};

export type SendNormalChatMessageInput = {
  attachments: Array<SendChatMessageAttachmentInput>;
  chatRoomId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  sendAsStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendNormalChatMessagePayload = {
  __typename?: 'SendNormalChatMessagePayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type SendNormalChatMessagesInput = {
  chatRoomIds: Array<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  sendAsStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendNormalChatMessagesPayload = {
  __typename?: 'SendNormalChatMessagesPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type SendQuestionChatMessageInput = {
  answerSelections: Array<Scalars['String']['input']>;
  chatRoomId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  sendAsStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendQuestionChatMessagePayload = {
  __typename?: 'SendQuestionChatMessagePayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type SendQuestionChatMessagesInput = {
  answerSelections: Array<Scalars['String']['input']>;
  chatRoomIds: Array<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  sendAsStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendQuestionChatMessagesPayload = {
  __typename?: 'SendQuestionChatMessagesPayload';
  isSucceeded: Scalars['Boolean']['output'];
};

export type SimpleLifePlanning = {
  __typename?: 'SimpleLifePlanning';
  rows: Array<SimpleLifePlanningRow>;
};

export type SimpleLifePlanningLifeEvent = EducationEvent | UserEvent;

export type SimpleLifePlanningRow = {
  __typename?: 'SimpleLifePlanningRow';
  deltaYear: Scalars['Uint']['output'];
  educationCost: Scalars['Uint']['output'];
  events: Array<SimpleLifePlanningLifeEvent>;
  monthlyBalance: Scalars['Int']['output'];
  remainingAssets: Scalars['Int']['output'];
};

export type SolicitorCloudCorporation = {
  __typename?: 'SolicitorCloudCorporation';
  documents: Array<SolicitorCloudDocument>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SolicitorCloudCoverageDocument = {
  __typename?: 'SolicitorCloudCoverageDocument';
  corporation: SolicitorCloudCorporation;
  createdAt: Scalars['DateTime']['output'];
  currentDocumentVersion?: Maybe<SolicitorCloudCoverageDocumentVersion>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SolicitorCloudCoverageDocumentSearchResult = {
  __typename?: 'SolicitorCloudCoverageDocumentSearchResult';
  documentVersion: SolicitorCloudCoverageDocumentVersion;
  fullText: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
};

export type SolicitorCloudCoverageDocumentVersion = {
  __typename?: 'SolicitorCloudCoverageDocumentVersion';
  document: SolicitorCloudCoverageDocument;
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['DateTime']['output'];
};

export type SolicitorCloudDocument = SolicitorCloudCoverageDocument | SolicitorCloudPamphletDocument;

export type SolicitorCloudPamphletDocument = {
  __typename?: 'SolicitorCloudPamphletDocument';
  corporation: SolicitorCloudCorporation;
  createdAt: Scalars['DateTime']['output'];
  currentDocumentVersion?: Maybe<SolicitorCloudPamphletDocumentVersion>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SolicitorCloudPamphletDocumentVersion = {
  __typename?: 'SolicitorCloudPamphletDocumentVersion';
  document: SolicitorCloudPamphletDocument;
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['DateTime']['output'];
};

export type SolicitorCloudSalesMaterial = {
  __typename?: 'SolicitorCloudSalesMaterial';
  createdAt: Scalars['DateTime']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pdfFilePath?: Maybe<Scalars['String']['output']>;
  publishedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export const SortKey = {
  KarteScoreOriginal: 'KARTE_SCORE_ORIGINAL'
} as const;

export type SortKey = typeof SortKey[keyof typeof SortKey];
export type Staff = {
  __typename?: 'Staff';
  connectedThirdPartyProvider?: Maybe<OAuthProvider>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  plannerAccountID: Scalars['ID']['output'];
  profile: StaffProfile;
  role: StaffRole;
};

export type StaffAuthzPolicyPrincipal = {
  __typename?: 'StaffAuthzPolicyPrincipal';
  staffGUID: Scalars['ID']['output'];
};

export type StaffAuthzPolicyPrincipalInput = {
  staffGUID: Scalars['ID']['input'];
};

export type StaffProfile = {
  __typename?: 'StaffProfile';
  avatar?: Maybe<Scalars['ImagePath']['output']>;
};

export const StaffRole = {
  BranchManager: 'BRANCH_MANAGER',
  CorporationAdmin: 'CORPORATION_ADMIN',
  EntranceManager: 'ENTRANCE_MANAGER',
  Member: 'MEMBER'
} as const;

export type StaffRole = typeof StaffRole[keyof typeof StaffRole];
export type StepDelivery = {
  __typename?: 'StepDelivery';
  IsDisabled: Scalars['Boolean']['output'];
  addFriendDate?: Maybe<Scalars['Date']['output']>;
  cond: Scalars['String']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startAt?: Maybe<Scalars['Date']['output']>;
  steps: Array<StepDeliveryStep>;
};

export type StepDeliveryStep = {
  __typename?: 'StepDeliveryStep';
  answerSelections?: Maybe<Array<StepDeliveryStepAnswerSelection>>;
  guid: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  messageType: Scalars['String']['output'];
  stepDeliveryGuid: Scalars['ID']['output'];
  targetDayAfter: Scalars['Int']['output'];
  targetHour: Scalars['Int']['output'];
};

export type StepDeliveryStepAnswerSelection = {
  __typename?: 'StepDeliveryStepAnswerSelection';
  guid: Scalars['ID']['output'];
  selection: Scalars['String']['output'];
  stepDeliveryStepGuid: Scalars['ID']['output'];
};

export type StepDeliveryStepAnswerSelectionInput = {
  guid?: InputMaybe<Scalars['ID']['input']>;
  selection: Scalars['String']['input'];
};

export type StepDeliveryStepInput = {
  answerSelections?: InputMaybe<Array<StepDeliveryStepAnswerSelectionInput>>;
  guid?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  targetDayAfter: Scalars['Int']['input'];
  targetHour: Scalars['Int']['input'];
};

export type StorePlannerAccountOAuthCredentialInput = {
  code: Scalars['String']['input'];
  provider: OAuthProvider;
  /**
   * https://accounts.google.com/gsi/clientのCodeClientに `uxmode: 'popup'` を設定
   * して取得した場合は取得時に利用したjavascriptを配信した Origin を入力すること
   */
  redirectUri: Scalars['String']['input'];
};

export type StorePlannerAccountOAuthCredentialPayload = StorePlannerAccountOAuthCredentialSuccessPayload;

export type StorePlannerAccountOAuthCredentialSuccessPayload = {
  __typename?: 'StorePlannerAccountOAuthCredentialSuccessPayload';
  isSucceed: Scalars['Boolean']['output'];
};

export const TargetType = {
  AllFriends: 'ALL_FRIENDS',
  AllMatchedUsers: 'ALL_MATCHED_USERS',
  Segment: 'SEGMENT'
} as const;

export type TargetType = typeof TargetType[keyof typeof TargetType];
export type Team = {
  __typename?: 'Team';
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  staffs: Array<Staff>;
};

export type TeamAuthzPolicyPrincipal = {
  __typename?: 'TeamAuthzPolicyPrincipal';
  teamGUID: Scalars['ID']['output'];
};

export type TeamAuthzPolicyPrincipalInput = {
  teamGUID: Scalars['ID']['input'];
};

/** 規約のリビジョン */
export type TermRevision = {
  __typename?: 'TermRevision';
  body: Scalars['MarkDown']['output'];
  /** リビジョンのID。規約が更新されたらIDが変わる */
  id: Scalars['ID']['output'];
  publishedAt: Scalars['Time']['output'];
  title: Scalars['String']['output'];
  type: TermType;
};

export const TermType = {
  /** プライバシーポリシー */
  PrivacyPolicy: 'PRIVACY_POLICY',
  /** 通信の秘密 */
  SecrecyOfCommunications: 'SECRECY_OF_COMMUNICATIONS',
  /** 利用規約 */
  TermsOfService: 'TERMS_OF_SERVICE'
} as const;

export type TermType = typeof TermType[keyof typeof TermType];
export type TimeSlot = {
  __typename?: 'TimeSlot';
  endsAt: Scalars['Time']['output'];
  startsAt: Scalars['Time']['output'];
};

export type TodoList = {
  __typename?: 'TodoList';
  /** 自動アプローチをONに促すTODOを表示するかどうか */
  showAutoKartePlannerCommentSetting: Scalars['Boolean']['output'];
  /** セミナー登録を促すTODOを表示するかどうか */
  showSeminar: Scalars['Boolean']['output'];
  /** プランナーのプロフィール設定を促すTODOを表示するかどうか */
  showWriteProfile: Scalars['Boolean']['output'];
};

export type UiControl = {
  __typename?: 'UIControl';
  editCorporation: Scalars['Boolean']['output'];
  editOkanekoCalendarSetting: Scalars['Boolean']['output'];
  editStaffs: Scalars['Boolean']['output'];
  useLineMessageFeatures: Scalars['Boolean']['output'];
  viewBranchMemberRooms: Scalars['Boolean']['output'];
  viewBranchReport: Scalars['Boolean']['output'];
  viewCorporationMemberRooms: Scalars['Boolean']['output'];
  viewCorporationReport: Scalars['Boolean']['output'];
  viewMatchedRooms: Scalars['Boolean']['output'];
};

export type UnassignStaffFromMatchErrorNotAuthorityPayload = {
  __typename?: 'UnassignStaffFromMatchErrorNotAuthorityPayload';
  message: Scalars['String']['output'];
};

export type UnassignStaffFromMatchInput = {
  matchID: Scalars['ID']['input'];
  staffGUID: Scalars['ID']['input'];
};

export type UnassignStaffFromMatchPayload = UnassignStaffFromMatchErrorNotAuthorityPayload | UnassignStaffFromMatchSuccessPayload;

export type UnassignStaffFromMatchSuccessPayload = {
  __typename?: 'UnassignStaffFromMatchSuccessPayload';
  match: Match;
};

export type UnknownError = Error & {
  __typename?: 'UnknownError';
  message: Scalars['String']['output'];
};

export type UpdateAttackListSenderSettingInput = {
  body: Scalars['String']['input'];
  entranceGuid?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
  plannerId?: InputMaybe<Scalars['ID']['input']>;
  rule: AttackListSenderSettingRuleInput;
  selections: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateAuthzPolicyInput = {
  action: AuthzPolicyActionInput;
  effect: AuthzPolicyEffect;
  guid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  principal: AuthzPolicyPrincipalInput;
  resource: AuthzPolicyResourceInput;
};

export type UpdateAuthzPolicyPayload = UpdateAuthzPolicySuccessPayload;

export type UpdateAuthzPolicySuccessPayload = {
  __typename?: 'UpdateAuthzPolicySuccessPayload';
  authzPolicy: AuthzPolicy;
};

export type UpdateAutoChatReplySettingInput = {
  body: Scalars['String']['input'];
  extra: AutoChatReplySettingInputExtra;
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
  keyword: Scalars['String']['input'];
};

export type UpdateAutoChatReplySettingPayload = AutoChatReplySettingDuplicateKeywordError | SaveAutoChatReplySettingSuccess;

export type UpdateCalendarInput = {
  guid: Scalars['ID']['input'];
  setting: CalendarSettingInput;
};

export type UpdateCalendarPayload = {
  __typename?: 'UpdateCalendarPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateChatMessageTemplateInput = {
  body: Scalars['String']['input'];
  guid: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  selections: Array<Scalars['String']['input']>;
};

export type UpdateConditionalIntroductionMessageInput = {
  condition: IntroductionMessageConditionInput;
  content: IntroductionMessageContentInput;
  guid: Scalars['ID']['input'];
};

export type UpdateConditionalIntroductionMessagePayload = AlreadyExistsConditionalIntroductionMessageError | SaveIntroductionMessageSuccess;

/** 渡されないプロパティは更新されない */
export type UpdateContractInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  invoiceCustomerName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEnqueteInput = {
  enquete: EnqueteInput;
  guid: Scalars['ID']['input'];
};

export type UpdateEnquetePayload = {
  __typename?: 'UpdateEnquetePayload';
  void: Scalars['Void']['output'];
};

export type UpdateKartePlannerCommentTemplateInput = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  selections: Array<Scalars['String']['input']>;
};

export type UpdateKollegeExpenseRecordDailyLessonInstructorCommentInput = {
  expenseRecordDailyLessonInputID: Scalars['ID']['input'];
  instructorComment: NullableString;
};

export type UpdateKollegeUserAddressInput = {
  building: Scalars['String']['input'];
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
  town: Scalars['String']['input'];
};

export type UpdateKollegeUserCourseInstructor = {
  instructorID: Scalars['String']['input'];
  userCourseID: Scalars['ID']['input'];
};

export type UpdateKollegeUserInput = {
  id: Scalars['ID']['input'];
  isAntiSocial?: InputMaybe<NullableBoolean>;
};

export type UpdateKollegeUserInstructorMemoInput = {
  id: Scalars['ID']['input'];
  memo: Scalars['String']['input'];
};

export type UpdateKollegeUserInstructorMemoResponse = {
  __typename?: 'UpdateKollegeUserInstructorMemoResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateKollegeUserProfileAndAddressInput = {
  address: UpdateKollegeUserAddressInput;
  id: Scalars['ID']['input'];
  profile: UpdateKollegeUserProfileInput;
};

export type UpdateKollegeUserProfileAndAddressResponse = {
  __typename?: 'UpdateKollegeUserProfileAndAddressResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateKollegeUserProfileInput = {
  familyName: Scalars['String']['input'];
  familyNameKana: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  givenNameKana: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLineActivationProviderSettingInput = {
  liffId?: InputMaybe<Scalars['String']['input']>;
  lineChannelId?: InputMaybe<Scalars['String']['input']>;
  lineFollowUrl?: InputMaybe<Scalars['String']['input']>;
  messageApiAccessToken: Scalars['String']['input'];
  messageApiChannelSecret: Scalars['String']['input'];
};

export type UpdateLineRichMenuInput = {
  guid: Scalars['ID']['input'];
  lineRichMenu: LineRichMenuInput;
};

export type UpdateLineRichMenuPayload = LineRichMenuErrorPayload | UpdateLineRichMenuSuccessPayload;

export type UpdateLineRichMenuSuccessPayload = {
  __typename?: 'UpdateLineRichMenuSuccessPayload';
  lineRichMenu: LineRichMenu;
};

export type UpdateLoginLinkRedirectUriInput = {
  redirectURI: Scalars['String']['input'];
};

export type UpdateLoginLinkRedirectUriPayload = UpdateLoginLinkRedirectUriSuccessPayload;

export type UpdateLoginLinkRedirectUriSuccessPayload = {
  __typename?: 'UpdateLoginLinkRedirectURISuccessPayload';
  void: Scalars['Void']['output'];
};

export type UpdatePlannerBookingRequestCalendarSettingInput = {
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
};

export type UpdatePlannerBookingRequestCalendarSettingPayload = UpdatePlannerBookingRequestCalendarSettingSuccess;

export type UpdatePlannerBookingRequestCalendarSettingSuccess = {
  __typename?: 'UpdatePlannerBookingRequestCalendarSettingSuccess';
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
};

export type UpdatePlannerInput = {
  availableAreaCodes: Array<Scalars['String']['input']>;
  availableTime: Scalars['String']['input'];
  avatarFileName?: InputMaybe<Scalars['String']['input']>;
  birthday: Scalars['Date']['input'];
  comment: Scalars['String']['input'];
  coverFileName?: InputMaybe<Scalars['String']['input']>;
  gender: Scalars['String']['input'];
  specialties: Array<Scalars['ID']['input']>;
};

export type UpdatePlannerProfileInput = {
  /** 回答しない場合はnull */
  address?: InputMaybe<AddressInput>;
  childrenState: ChildrenStateInput;
};

export type UpdateScenarioChatInput = {
  guid: Scalars['ID']['input'];
  messages: Array<ScenarioChatMessageInput>;
  title: Scalars['String']['input'];
};

export type UpdateScenarioChatPayload = {
  __typename?: 'UpdateScenarioChatPayload';
  guid: Scalars['ID']['output'];
};

export type UpdateScheduledTimeOfChatMessageSendingJobErrorPayload = {
  __typename?: 'UpdateScheduledTimeOfChatMessageSendingJobErrorPayload';
  reason: Scalars['String']['output'];
};

export type UpdateScheduledTimeOfChatMessageSendingJobInput = {
  guid: Scalars['ID']['input'];
  /**
   * 更新する送信日時
   * nullに更新すると即時送信されるので注意！
   */
  scheduledAt?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateScheduledTimeOfChatMessageSendingJobPayload = UpdateScheduledTimeOfChatMessageSendingJobErrorPayload | UpdateScheduledTimeOfChatMessageSendingJobSuccessPayload;

export type UpdateScheduledTimeOfChatMessageSendingJobSuccessPayload = {
  __typename?: 'UpdateScheduledTimeOfChatMessageSendingJobSuccessPayload';
  jobGuid?: Maybe<Scalars['ID']['output']>;
};

export type UpdateStaffErrorNotAuthorityPayload = {
  __typename?: 'UpdateStaffErrorNotAuthorityPayload';
  message: Scalars['String']['output'];
};

export type UpdateStaffInput = {
  guid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<StaffRole>;
};

export type UpdateStaffPayload = UpdateStaffErrorNotAuthorityPayload | UpdateStaffSuccessPayload;

export type UpdateStaffProfileInput = {
  avatarImageName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStaffProfilePayload = UpdateStaffProfileSuccessPayload;

export type UpdateStaffProfileSuccessPayload = {
  __typename?: 'UpdateStaffProfileSuccessPayload';
  staff: Staff;
};

export type UpdateStaffSuccessPayload = {
  __typename?: 'UpdateStaffSuccessPayload';
  staff: Staff;
};

export type UpdateStepDeliveryInput = {
  IsDisabled: Scalars['Boolean']['input'];
  addFriendDate?: InputMaybe<Scalars['Date']['input']>;
  cond: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['Date']['input']>;
  guid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
  steps: Array<StepDeliveryStepInput>;
};

export type UpdateStepDeliveryPayload = {
  __typename?: 'UpdateStepDeliveryPayload';
  StepDelivery: StepDelivery;
};

export type UpdateTeamInput = {
  guid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  staffGUIDs: Array<Scalars['ID']['input']>;
};

export type UpdateTeamPayload = UpdateTeamSuccessPayload;

export type UpdateTeamSuccessPayload = {
  __typename?: 'UpdateTeamSuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateUserRegistrationInflowSourceDefinitionInput = {
  guid: Scalars['ID']['input'];
  inflowSourceName: Scalars['String']['input'];
  matchAssignedStaffGUIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  useShortenedURL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserRegistrationInflowSourceDefinitionPayload = {
  __typename?: 'UpdateUserRegistrationInflowSourceDefinitionPayload';
  guid: Scalars['ID']['output'];
};

export type UpdateUserVariableDefinitionInput = {
  guid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUserVariableDefinitionPayload = {
  __typename?: 'UpdateUserVariableDefinitionPayload';
  void: Scalars['Void']['output'];
};

export type UpdateUserVariableDefinitionValueSelectOptionInput = {
  name: Scalars['String']['input'];
  selectOptionGUID: Scalars['ID']['input'];
  userVariableDefinitionGUID: Scalars['ID']['input'];
};

export type UpdateUserVariableDefinitionValueSelectOptionPayload = {
  __typename?: 'UpdateUserVariableDefinitionValueSelectOptionPayload';
  void: Scalars['Void']['output'];
};

export type UploadFile = {
  file: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};

export type UploadRequestInput = {
  id: Scalars['ID']['input'];
  originalFileName: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<UserAddress>;
  birthYear?: Maybe<Scalars['Uint']['output']>;
  channel: Channel;
  /** 自身(Planner)とやり取りをしているチャットルームを返す */
  chatRoom?: Maybe<ChatRoom>;
  diagnosis?: Maybe<Diagnosis>;
  diagnosisResult?: Maybe<DiagnosisResult>;
  financialServicesAgent?: Maybe<Scalars['String']['output']>;
  gender: UserGender;
  id: Scalars['ID']['output'];
  /** @deprecated Use lineActivationUser instead */
  isLineActivationUser: Scalars['Boolean']['output'];
  karte?: Maybe<Karte>;
  lineActivationUser?: Maybe<LineActivationUser>;
  livingPrefecture?: Maybe<Prefecture>;
  nickname: Scalars['String']['output'];
  numberOfMatch: Scalars['Uint']['output'];
  userRegistrationInflowSource?: Maybe<Scalars['String']['output']>;
  userVariableValues: Array<UserVariableValue>;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  city: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
};

export type UserCoursePeriod = {
  __typename?: 'UserCoursePeriod';
  endsAt: Scalars['Time']['output'];
  startsAt: Scalars['Time']['output'];
};

export type UserEvent = {
  __typename?: 'UserEvent';
  type: UserEventType;
};

export const UserEventType = {
  MandatoryRetirement: 'MANDATORY_RETIREMENT',
  ThePresentTime: 'THE_PRESENT_TIME'
} as const;

export type UserEventType = typeof UserEventType[keyof typeof UserEventType];
export const UserGender = {
  Female: 'FEMALE',
  Male: 'MALE',
  NoAnswer: 'NO_ANSWER',
  Other: 'OTHER'
} as const;

export type UserGender = typeof UserGender[keyof typeof UserGender];
export type UserRegistrationInflowSourceDefinition = {
  __typename?: 'UserRegistrationInflowSourceDefinition';
  guid: Scalars['ID']['output'];
  inflowCount: Scalars['Uint']['output'];
  inflowSourceName: Scalars['String']['output'];
  matchAssigned: MatchAssigned;
  url: Scalars['String']['output'];
  useShortenedURL: Scalars['Boolean']['output'];
};

export type UserVariableDefinition = {
  __typename?: 'UserVariableDefinition';
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: UserVariableDefinitionValue;
};

export const UserVariableDefinitionDataType = {
  MultipleSelect: 'MULTIPLE_SELECT',
  Select: 'SELECT',
  String: 'STRING',
  Text: 'TEXT'
} as const;

export type UserVariableDefinitionDataType = typeof UserVariableDefinitionDataType[keyof typeof UserVariableDefinitionDataType];
export type UserVariableDefinitionValue = UserVariableDefinitionValueMultipleSelect | UserVariableDefinitionValueSelect | UserVariableDefinitionValueString | UserVariableDefinitionValueText;

export type UserVariableDefinitionValueMultipleSelect = {
  __typename?: 'UserVariableDefinitionValueMultipleSelect';
  options: Array<UserVariableDefinitionValueSelectOption>;
};

export type UserVariableDefinitionValueSelect = {
  __typename?: 'UserVariableDefinitionValueSelect';
  options: Array<UserVariableDefinitionValueSelectOption>;
};

export type UserVariableDefinitionValueSelectOption = {
  __typename?: 'UserVariableDefinitionValueSelectOption';
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserVariableDefinitionValueString = {
  __typename?: 'UserVariableDefinitionValueString';
  void: Scalars['Void']['output'];
};

export type UserVariableDefinitionValueText = {
  __typename?: 'UserVariableDefinitionValueText';
  void: Scalars['Void']['output'];
};

export type UserVariableValue = {
  __typename?: 'UserVariableValue';
  definition: UserVariableDefinition;
  guid: Scalars['ID']['output'];
  value: UserVariableValue_Value;
};

export type UserVariableValue_Value = UserVariableValue_ValueMultipleSelect | UserVariableValue_ValueSelect | UserVariableValue_ValueString | UserVariableValue_ValueText;

export type UserVariableValue_ValueMultipleSelect = {
  __typename?: 'UserVariableValue_ValueMultipleSelect';
  optionGUIDs: Array<Scalars['String']['output']>;
};

export type UserVariableValue_ValueSelect = {
  __typename?: 'UserVariableValue_ValueSelect';
  optionGUID: Scalars['String']['output'];
};

export type UserVariableValue_ValueString = {
  __typename?: 'UserVariableValue_ValueString';
  value: Scalars['String']['output'];
};

export type UserVariableValue_ValueText = {
  __typename?: 'UserVariableValue_ValueText';
  value: Scalars['String']['output'];
};

export type V2021_1KartePlannerCommentMonthlyAmount = {
  __typename?: 'V2021_1KartePlannerCommentMonthlyAmount';
  /** V2021_1はチャンネルごとに利用量の集計をする。item1個につき1つのチャネルの集計結果 */
  items: Array<V2021_1KartePlannerCommentMonthlyAmountItem>;
};

export type V2021_1KartePlannerCommentMonthlyAmountItem = {
  __typename?: 'V2021_1KartePlannerCommentMonthlyAmountItem';
  /** 集計対象のチャネル */
  channel: Channel;
  /** コメント数上限件数 */
  upperLimit?: Maybe<Scalars['Uint']['output']>;
  /** コメントを送った件数 */
  usage: Scalars['Uint']['output'];
};

export type V2022_1KartePlannerCommentMonthlyAmount = {
  __typename?: 'V2022_1KartePlannerCommentMonthlyAmount';
  /** 追加料金無しで送れる件数 */
  freeAmount?: Maybe<Scalars['Uint']['output']>;
  /** コメント数上限件数 */
  upperLimit?: Maybe<Scalars['Uint']['output']>;
  /** コメントを送った件数 */
  usage: Scalars['Uint']['output'];
};

export type V2023_1KartePlannerCommentMonthlyAmount = {
  __typename?: 'V2023_1KartePlannerCommentMonthlyAmount';
  /** 追加料金無しで送れる件数 */
  freeAmount?: Maybe<Scalars['Uint']['output']>;
  /** コメント数上限件数 */
  upperLimit?: Maybe<Scalars['Uint']['output']>;
  /** コメントを送った件数 */
  usage: Scalars['Uint']['output'];
};

export const VerificationStrategy = {
  ApproveAll: 'APPROVE_ALL',
  IsActivated: 'IS_ACTIVATED',
  IsLoggedIn: 'IS_LOGGED_IN'
} as const;

export type VerificationStrategy = typeof VerificationStrategy[keyof typeof VerificationStrategy];
export type VerifyPasswordResetTokenPayload = {
  __typename?: 'VerifyPasswordResetTokenPayload';
  verified: Scalars['Boolean']['output'];
};

export type Viewer = {
  __typename?: 'Viewer';
  attackListSender: AttackListSenderFeature;
  autoChatReplySettings: Array<AutoChatReplySetting>;
  autoPostKartePlannerComment: AutoPostKartePlannerCommentFeature;
  availableTimeSlots: Array<TimeSlot>;
  bookingRequestCalendarSetting: PlannerBookingRequestCalendarSetting;
  channel: Array<Channel>;
  channels: Array<ChannelItem>;
  chatMessageTemplates: Array<ChatMessageTemplate>;
  hasLineActivationProvider: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is400FOA: Scalars['Boolean']['output'];
  is400FOkaneKollegeStaff: Scalars['Boolean']['output'];
  kartePlannerCommentMonthlyAmount: KartePlannerCommentMonthlyAmount;
  kartePlannerCommentTemplates: Array<KartePlannerCommentTemplate>;
  myStoryUrl?: Maybe<Scalars['String']['output']>;
  plan: Plan;
  /** プランナーの利用開始日 */
  plannerStartedAt: Scalars['Date']['output'];
  profile: PlannerProfile;
  /** プランナーが同意する必要のある規約。同意しないと機能が使えないようにする必要がある。 */
  requiredAgreementTerms: Array<TermRevision>;
  staff: Staff;
  /** @deprecated availableBookingRequestTimeSlots を使う */
  todoList: TodoList;
};


export type ViewerAvailableTimeSlotsArgs = {
  from: Scalars['Time']['input'];
  until: Scalars['Time']['input'];
};
